"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f110 = void 0;
exports.f110 = {
    "ng": [
        8,
        9,
        43,
        44,
        45,
        61,
        72,
        105,
        138,
        143,
        144,
        151,
        152,
        188,
        192,
        205,
        228,
        235,
        237,
        257,
        262,
        286,
        299,
        317,
        325,
        328,
        340,
        397,
        398,
        466,
        491,
        520,
        522,
        548,
        556,
        577,
        580,
        581,
        589,
        627,
        652,
        653,
        654,
        672,
        678,
        681,
        683,
        689,
        779,
        798,
        845,
        847,
        886,
        906,
        909,
        944,
        1011,
        1012,
        1065,
        1072,
        1073,
        1099,
        1120,
        1124,
        1127,
        1134,
        1142,
        1144,
        1148,
        1162,
        1163,
        1181,
        1188,
        1193,
        1195,
        1203,
        1205,
        1217,
        1240,
        1263,
        1265,
        1273,
        1276,
        1280,
        1287,
        1290,
        1319,
        1321,
        1322,
        1362,
        1363,
        1375,
        1376,
        1401,
        1422,
        1423,
        1425,
        1426,
        1427,
        1468,
        1500,
        1512,
        1514,
        1625,
        1733,
        1748,
        1749,
        1753,
        1757,
        1759,
        1760,
        1765,
        1797,
        1819,
        1858,
        1860,
        1887,
        1901,
        1935,
        1947,
        1959,
        2022,
        2045,
        2052,
        2064,
        2066,
        2069,
        2072,
        2077,
        2078,
        2080,
        2082,
        2087,
        2088,
        2098,
        2102,
        2187,
        2235,
        2240,
        2241,
        2245,
        2248,
        2304,
        2310,
        2313,
        2314,
        2319,
        2327,
        2328,
        2336,
        2341,
        2362,
        2375,
        2386,
        2390,
        2394,
        2398,
        2491,
        2497,
        2498,
        2557,
        2563,
        2579,
        2580,
        2595,
        2597,
        2600,
        2602,
        2606,
        2607,
        2611,
        2639,
        2670,
        2675,
        2683,
        2686,
        2690,
        2702,
        2708,
        2710,
        2753,
        2756,
        2767,
        2769,
        2803,
        2833,
        2842,
        2847,
        2851,
        2860,
        2870,
        2874,
        2875,
        2876,
        2912,
        2937,
        2942,
        3024,
        3025,
        3060,
        3103,
        3116,
        3118,
        3122,
        3123,
        3124,
        3126,
        3128,
        3136,
        3138,
        3141,
        3143,
        3154,
        3155,
        3156,
        3158,
        3164,
        3166,
        3172,
        3173,
        3175,
        3176,
        3179,
        3180,
        3181,
        3182,
        3183,
        3188,
        3189,
        3204,
        3234,
        3237,
        3251,
        3252,
        3256,
        3271,
        3274,
        3277,
        3296,
        3300,
        3301,
        3306,
        3310,
        3329,
        3351,
        3352,
        3358,
        3363,
        3365,
        3366,
        3379,
        3386,
        3390,
        3393,
        3397,
        3403,
        3422,
        3423,
        3427,
        3430,
        3432,
        3436,
        3441,
        3442,
        3462,
        3467,
        3468,
        3505,
        3508,
        3510,
        3511,
        3512,
        3513,
        3514,
        3522,
        3524,
        3543,
        3544,
        3546,
        3555,
        3576,
        3585,
        3637,
        3653,
        3681,
        3735,
        3738,
        3749,
        3754,
        3755,
        3757,
        3774,
        3778,
        3801,
        3816,
        3821,
        3826,
        3852,
        3855,
        3869,
        3870,
        3873,
        3884,
        3925,
        3926,
        3933,
        3940,
        3954,
        3966,
        3968,
        3970,
        3984,
        4015,
        4020,
        4021,
        4025,
        4074,
        4084,
        4203,
        4206,
        4253,
        4254,
        4255,
        4256,
        4258,
        4259,
        4260,
        4263,
        4264,
        4265,
        4374,
        4436,
        4455,
        4574,
        4619,
        4634,
        4651,
        4703,
        4721,
        4722,
        4723,
        4724,
        4748,
        4749,
        4835,
        4851,
        4860,
        4899,
        4906,
        4966,
        5060,
        5112,
        5266,
        5268,
        5301,
        5303,
        5311,
        5316,
        5322,
        5323,
        5325,
        5362,
        5366,
        5374,
        5392,
        5416,
        5428,
        5437,
        5441,
        5442,
        5480,
        5493,
        5503,
        5534,
        5535,
        5570,
        5659,
        5683,
        5689,
        5731,
        5739,
        5740,
        5833,
        5840,
        5843,
        5847,
        5848,
        5849,
        5851,
        5852,
        5853,
        5872,
        5874,
        5875,
        5885,
        5886,
        5889,
        5895,
        5942,
        5953,
        5957,
        5963,
        5975,
        6026,
        6050,
        6052,
        6077,
        6078,
        6080,
        6118,
        6156,
        6164,
        6189,
        6228,
        6280,
        6375,
        6385,
        6483,
        6503,
        6525,
        6583,
        6625,
        6633,
        6634,
        6686,
        6738,
        6739,
        6750,
        6830,
        6849,
        6881,
        7075,
        7076,
        7198,
        7263,
        7270,
        7311,
        7312,
        7313,
        7395,
        7396,
        7399,
        7400,
        7404,
        7449,
        7490,
        7515,
        7546,
        7749,
        7756,
        7771,
        7793,
        7805,
        7847,
        7862,
        7877,
        7896,
        7905,
        7926,
        7930,
        7938,
        7939,
        7941,
        7942,
        7944,
        7945,
        7962,
        7970,
        7998,
        8020,
        8022,
        8024,
        8026,
        8037,
        8072,
        8075,
        8088,
        8095,
        8101,
        8132,
        8170,
        8244,
        8245,
        8271,
        8315,
        8390,
        8575,
        8632,
        8635,
        8744,
        8745,
        8746,
        8752,
        8754,
        8775,
        8776,
        8866,
        8869,
        8870,
        8872,
        8880,
        8934,
        8978,
        8995,
        9001,
        9046,
        9058,
        9112,
        9174
    ],
    "nigeria": [
        5266,
        8271,
        2498,
        520,
        627,
        654,
        672,
        1072,
        1280,
        1319,
        3393,
        3397,
        3774,
        3801,
        3821,
        4203,
        4651,
        6050,
        6633,
        8315,
        8635,
        8934,
        8,
        9,
        43,
        44,
        45,
        61,
        72,
        105,
        138,
        143,
        144,
        151,
        152,
        188,
        192,
        205,
        228,
        235,
        237,
        257,
        262,
        286,
        299,
        317,
        325,
        328,
        340,
        397,
        398,
        466,
        491,
        522,
        548,
        556,
        577,
        580,
        581,
        589,
        652,
        653,
        678,
        681,
        683,
        689,
        779,
        798,
        845,
        847,
        886,
        906,
        909,
        944,
        1011,
        1012,
        1065,
        1073,
        1099,
        1120,
        1124,
        1127,
        1134,
        1142,
        1144,
        1148,
        1162,
        1163,
        1181,
        1188,
        1193,
        1195,
        1203,
        1205,
        1217,
        1240,
        1263,
        1265,
        1273,
        1276,
        1287,
        1290,
        1321,
        1322,
        1362,
        1363,
        1375,
        1376,
        1401,
        1422,
        1423,
        1425,
        1426,
        1427,
        1468,
        1500,
        1512,
        1514,
        1625,
        1733,
        1748,
        1749,
        1753,
        1757,
        1759,
        1760,
        1765,
        1797,
        1819,
        1858,
        1860,
        1887,
        1901,
        1935,
        1947,
        1959,
        2022,
        2045,
        2052,
        2064,
        2066,
        2069,
        2072,
        2077,
        2078,
        2080,
        2082,
        2087,
        2088,
        2098,
        2102,
        2187,
        2235,
        2240,
        2241,
        2245,
        2248,
        2304,
        2310,
        2313,
        2314,
        2319,
        2327,
        2328,
        2336,
        2341,
        2362,
        2375,
        2386,
        2390,
        2394,
        2398,
        2491,
        2497,
        2557,
        2563,
        2579,
        2580,
        2595,
        2597,
        2600,
        2602,
        2606,
        2607,
        2611,
        2639,
        2670,
        2675,
        2683,
        2686,
        2690,
        2702,
        2708,
        2710,
        2753,
        2756,
        2767,
        2769,
        2803,
        2833,
        2842,
        2847,
        2851,
        2860,
        2870,
        2874,
        2875,
        2876,
        2912,
        2937,
        2942,
        3024,
        3025,
        3060,
        3103,
        3116,
        3118,
        3122,
        3123,
        3124,
        3126,
        3128,
        3136,
        3138,
        3141,
        3143,
        3154,
        3155,
        3156,
        3158,
        3164,
        3166,
        3172,
        3173,
        3175,
        3176,
        3179,
        3180,
        3181,
        3182,
        3183,
        3188,
        3189,
        3204,
        3234,
        3237,
        3251,
        3252,
        3256,
        3271,
        3274,
        3277,
        3296,
        3300,
        3301,
        3306,
        3310,
        3329,
        3351,
        3352,
        3358,
        3363,
        3365,
        3366,
        3379,
        3386,
        3390,
        3403,
        3422,
        3423,
        3427,
        3430,
        3432,
        3436,
        3441,
        3442,
        3462,
        3467,
        3468,
        3505,
        3508,
        3510,
        3511,
        3512,
        3513,
        3514,
        3522,
        3524,
        3543,
        3544,
        3546,
        3555,
        3576,
        3585,
        3637,
        3653,
        3681,
        3735,
        3738,
        3749,
        3754,
        3755,
        3757,
        3778,
        3816,
        3826,
        3852,
        3855,
        3869,
        3870,
        3873,
        3884,
        3925,
        3926,
        3933,
        3940,
        3954,
        3966,
        3968,
        3970,
        3984,
        4015,
        4020,
        4021,
        4025,
        4074,
        4084,
        4206,
        4253,
        4254,
        4255,
        4256,
        4258,
        4259,
        4260,
        4263,
        4264,
        4265,
        4374,
        4436,
        4455,
        4574,
        4619,
        4634,
        4703,
        4721,
        4722,
        4723,
        4724,
        4748,
        4749,
        4835,
        4851,
        4860,
        4899,
        4906,
        4966,
        5060,
        5112,
        5268,
        5301,
        5303,
        5311,
        5316,
        5322,
        5323,
        5325,
        5362,
        5366,
        5374,
        5392,
        5416,
        5428,
        5437,
        5441,
        5442,
        5480,
        5493,
        5503,
        5534,
        5535,
        5570,
        5659,
        5683,
        5689,
        5731,
        5739,
        5740,
        5833,
        5840,
        5843,
        5847,
        5848,
        5849,
        5851,
        5852,
        5853,
        5872,
        5874,
        5875,
        5885,
        5886,
        5889,
        5895,
        5942,
        5953,
        5957,
        5963,
        5975,
        6026,
        6052,
        6077,
        6078,
        6080,
        6118,
        6156,
        6164,
        6189,
        6228,
        6280,
        6375,
        6385,
        6483,
        6503,
        6525,
        6583,
        6625,
        6634,
        6686,
        6738,
        6739,
        6750,
        6830,
        6849,
        6881,
        7075,
        7076,
        7198,
        7263,
        7270,
        7311,
        7312,
        7313,
        7395,
        7396,
        7399,
        7400,
        7404,
        7449,
        7490,
        7515,
        7546,
        7749,
        7756,
        7771,
        7793,
        7805,
        7847,
        7862,
        7877,
        7896,
        7905,
        7926,
        7930,
        7938,
        7939,
        7941,
        7942,
        7944,
        7945,
        7962,
        7970,
        7998,
        8020,
        8022,
        8024,
        8026,
        8037,
        8072,
        8075,
        8088,
        8095,
        8101,
        8132,
        8170,
        8244,
        8245,
        8390,
        8575,
        8632,
        8744,
        8745,
        8746,
        8752,
        8754,
        8775,
        8776,
        8866,
        8869,
        8870,
        8872,
        8880,
        8978,
        8995,
        9001,
        9046,
        9058,
        9112,
        9174
    ],
    "new": [
        5818,
        3319,
        6120,
        1478,
        1479,
        1480,
        2329,
        3957,
        4790,
        7666,
        297,
        547,
        586,
        739,
        870,
        957,
        1046,
        1941,
        2649,
        3517,
        3798,
        3862,
        4018,
        4119,
        4286,
        4378,
        4653,
        4670,
        4830,
        5106,
        5109,
        5587,
        6059,
        6091,
        6693,
        6878,
        7052,
        8004,
        8281,
        121,
        222,
        319,
        356,
        402,
        571,
        1034,
        1221,
        1340,
        1474,
        1507,
        1842,
        1999,
        2191,
        2451,
        2501,
        3098,
        3111,
        3324,
        3542,
        4865,
        5050,
        5089,
        5393,
        5399,
        5400,
        5401,
        5725,
        6165,
        6206,
        6260,
        6290,
        6873,
        8033,
        8280,
        8838,
        10,
        11,
        15,
        16,
        17,
        18,
        26,
        27,
        38,
        51,
        52,
        53,
        56,
        58,
        99,
        111,
        129,
        130,
        131,
        137,
        141,
        142,
        145,
        153,
        154,
        156,
        162,
        163,
        165,
        196,
        198,
        199,
        206,
        218,
        239,
        240,
        247,
        250,
        264,
        279,
        298,
        300,
        304,
        322,
        324,
        341,
        343,
        345,
        347,
        348,
        349,
        350,
        353,
        354,
        355,
        358,
        359,
        371,
        372,
        373,
        383,
        386,
        387,
        394,
        473,
        482,
        485,
        490,
        516,
        518,
        521,
        523,
        525,
        530,
        533,
        542,
        552,
        554,
        562,
        563,
        573,
        634,
        637,
        639,
        647,
        651,
        655,
        665,
        667,
        671,
        673,
        680,
        688,
        690,
        720,
        726,
        729,
        749,
        812,
        813,
        819,
        840,
        842,
        848,
        850,
        851,
        852,
        861,
        865,
        869,
        875,
        876,
        885,
        927,
        946,
        951,
        954,
        959,
        964,
        967,
        968,
        987,
        993,
        1009,
        1013,
        1015,
        1016,
        1021,
        1029,
        1032,
        1036,
        1044,
        1061,
        1068,
        1096,
        1112,
        1113,
        1157,
        1182,
        1185,
        1187,
        1189,
        1191,
        1209,
        1224,
        1227,
        1232,
        1234,
        1253,
        1255,
        1270,
        1275,
        1289,
        1294,
        1295,
        1302,
        1304,
        1341,
        1433,
        1488,
        1493,
        1506,
        1723,
        1724,
        1728,
        1767,
        1775,
        1794,
        1811,
        1817,
        1818,
        1831,
        1832,
        1845,
        1884,
        1898,
        1915,
        1924,
        1930,
        1931,
        1934,
        1940,
        1997,
        2003,
        2004,
        2021,
        2028,
        2074,
        2075,
        2094,
        2097,
        2100,
        2106,
        2192,
        2227,
        2237,
        2249,
        2309,
        2331,
        2333,
        2335,
        2337,
        2338,
        2377,
        2392,
        2411,
        2414,
        2417,
        2472,
        2499,
        2513,
        2517,
        2518,
        2519,
        2522,
        2526,
        2527,
        2529,
        2531,
        2533,
        2543,
        2544,
        2565,
        2570,
        2578,
        2589,
        2592,
        2598,
        2615,
        2623,
        2624,
        2626,
        2636,
        2647,
        2667,
        2668,
        2691,
        2697,
        2715,
        2719,
        2720,
        2725,
        2732,
        2755,
        2768,
        2774,
        2783,
        2784,
        2786,
        2791,
        2793,
        2829,
        2830,
        2839,
        2858,
        2889,
        2897,
        2899,
        2929,
        2930,
        2932,
        2943,
        2961,
        2964,
        2992,
        3015,
        3016,
        3018,
        3035,
        3046,
        3055,
        3076,
        3079,
        3082,
        3112,
        3114,
        3139,
        3157,
        3159,
        3161,
        3206,
        3208,
        3209,
        3222,
        3229,
        3231,
        3232,
        3246,
        3273,
        3291,
        3293,
        3309,
        3328,
        3353,
        3370,
        3382,
        3389,
        3398,
        3487,
        3489,
        3494,
        3498,
        3501,
        3502,
        3507,
        3520,
        3525,
        3536,
        3565,
        3581,
        3624,
        3638,
        3654,
        3662,
        3669,
        3678,
        3680,
        3686,
        3687,
        3690,
        3699,
        3721,
        3725,
        3726,
        3737,
        3771,
        3776,
        3779,
        3780,
        3784,
        3788,
        3799,
        3800,
        3806,
        3807,
        3810,
        3812,
        3815,
        3837,
        3842,
        3851,
        3864,
        3872,
        3879,
        3890,
        3894,
        3895,
        3898,
        3899,
        3900,
        3903,
        3906,
        3907,
        3909,
        3920,
        3958,
        3962,
        3963,
        3965,
        3971,
        3992,
        3994,
        3996,
        4017,
        4030,
        4031,
        4047,
        4051,
        4082,
        4087,
        4098,
        4121,
        4125,
        4128,
        4134,
        4138,
        4159,
        4160,
        4166,
        4216,
        4219,
        4232,
        4236,
        4237,
        4248,
        4273,
        4275,
        4282,
        4283,
        4285,
        4310,
        4325,
        4327,
        4332,
        4365,
        4379,
        4385,
        4399,
        4429,
        4432,
        4448,
        4458,
        4501,
        4522,
        4560,
        4606,
        4609,
        4615,
        4621,
        4622,
        4627,
        4633,
        4641,
        4642,
        4646,
        4649,
        4650,
        4652,
        4681,
        4683,
        4684,
        4689,
        4700,
        4701,
        4729,
        4732,
        4751,
        4760,
        4761,
        4772,
        4777,
        4814,
        4825,
        4826,
        4829,
        4849,
        4861,
        4863,
        4878,
        4881,
        4889,
        4909,
        4915,
        4916,
        4917,
        4919,
        4923,
        4933,
        4948,
        4980,
        4995,
        4997,
        4998,
        4999,
        5002,
        5003,
        5005,
        5007,
        5013,
        5030,
        5031,
        5035,
        5092,
        5095,
        5096,
        5097,
        5103,
        5122,
        5125,
        5137,
        5146,
        5150,
        5160,
        5162,
        5165,
        5175,
        5176,
        5177,
        5180,
        5181,
        5215,
        5217,
        5227,
        5251,
        5261,
        5276,
        5281,
        5285,
        5287,
        5290,
        5291,
        5302,
        5305,
        5319,
        5332,
        5333,
        5336,
        5338,
        5339,
        5346,
        5347,
        5348,
        5398,
        5406,
        5412,
        5457,
        5469,
        5472,
        5475,
        5484,
        5489,
        5492,
        5517,
        5523,
        5586,
        5596,
        5602,
        5604,
        5619,
        5623,
        5625,
        5632,
        5636,
        5646,
        5656,
        5680,
        5694,
        5700,
        5727,
        5741,
        5742,
        5749,
        5754,
        5768,
        5784,
        5858,
        5880,
        5888,
        5912,
        5917,
        5923,
        5925,
        5926,
        5927,
        5931,
        5932,
        5933,
        5944,
        5945,
        5956,
        5978,
        6000,
        6003,
        6005,
        6010,
        6081,
        6098,
        6102,
        6105,
        6114,
        6154,
        6163,
        6170,
        6182,
        6217,
        6235,
        6239,
        6268,
        6273,
        6274,
        6276,
        6278,
        6293,
        6302,
        6320,
        6322,
        6346,
        6366,
        6372,
        6374,
        6376,
        6462,
        6465,
        6469,
        6492,
        6516,
        6549,
        6557,
        6584,
        6591,
        6597,
        6599,
        6637,
        6641,
        6642,
        6695,
        6698,
        6699,
        6707,
        6755,
        6783,
        6788,
        6796,
        6828,
        6875,
        6880,
        6883,
        6884,
        6885,
        6886,
        6905,
        6914,
        6922,
        6931,
        6949,
        6958,
        6964,
        6965,
        6967,
        6968,
        6978,
        6988,
        6992,
        7006,
        7007,
        7009,
        7014,
        7015,
        7016,
        7037,
        7040,
        7045,
        7051,
        7055,
        7056,
        7057,
        7063,
        7100,
        7106,
        7125,
        7131,
        7135,
        7138,
        7143,
        7149,
        7150,
        7152,
        7155,
        7162,
        7168,
        7170,
        7187,
        7190,
        7191,
        7192,
        7195,
        7216,
        7240,
        7243,
        7322,
        7330,
        7331,
        7333,
        7334,
        7337,
        7343,
        7346,
        7349,
        7352,
        7363,
        7417,
        7448,
        7453,
        7456,
        7462,
        7498,
        7507,
        7509,
        7552,
        7564,
        7583,
        7590,
        7604,
        7611,
        7620,
        7630,
        7642,
        7660,
        7682,
        7685,
        7687,
        7688,
        7701,
        7707,
        7750,
        7758,
        7759,
        7776,
        7777,
        7781,
        7783,
        7784,
        7785,
        7790,
        7831,
        7836,
        7861,
        7892,
        7895,
        7899,
        7900,
        7901,
        7902,
        7915,
        7928,
        7933,
        7953,
        7968,
        7972,
        7980,
        7985,
        7997,
        7999,
        8002,
        8007,
        8009,
        8010,
        8011,
        8014,
        8021,
        8027,
        8034,
        8035,
        8053,
        8054,
        8055,
        8089,
        8110,
        8149,
        8154,
        8157,
        8168,
        8172,
        8174,
        8197,
        8204,
        8207,
        8211,
        8218,
        8220,
        8225,
        8234,
        8241,
        8242,
        8254,
        8273,
        8286,
        8287,
        8288,
        8298,
        8299,
        8306,
        8312,
        8319,
        8335,
        8337,
        8348,
        8349,
        8353,
        8356,
        8368,
        8372,
        8405,
        8418,
        8457,
        8459,
        8513,
        8517,
        8578,
        8585,
        8587,
        8626,
        8633,
        8637,
        8755,
        8757,
        8758,
        8759,
        8765,
        8767,
        8771,
        8779,
        8783,
        8784,
        8786,
        8789,
        8808,
        8818,
        8820,
        8823,
        8827,
        8828,
        8829,
        8830,
        8832,
        8837,
        8839,
        8848,
        8851,
        8852,
        8863,
        8873,
        8879,
        8892,
        8893,
        8901,
        8912,
        8917,
        8930,
        8938,
        8939,
        8945,
        8962,
        9008,
        9017,
        9051,
        9053,
        9088,
        9155,
        9159,
        9175
    ],
    "nub": [
        28,
        1238
    ],
    "norte": [
        35,
        623,
        1444,
        2233,
        5115,
        5343,
        5466,
        5718,
        6197,
        6216,
        6423,
        6440,
        7473,
        7576,
        7649,
        7691,
        8656
    ],
    "nyo": [
        42,
        5809
    ],
    "negrito": [
        46,
        175,
        400,
        503,
        2008,
        4914,
        6702
    ],
    "namatalaki": [
        59
    ],
    "north syrian arabic": [
        70
    ],
    "north": [
        5675,
        8594,
        368,
        585,
        663,
        2291,
        2399,
        2652,
        3647,
        3990,
        4388,
        4598,
        4720,
        4907,
        5057,
        5403,
        5529,
        5600,
        6404,
        6421,
        6423,
        6734,
        6735,
        6770,
        6771,
        7334,
        7625,
        7968,
        8556,
        8807,
        70,
        152,
        397,
        1284,
        1285,
        1961,
        2391,
        2395,
        3793,
        3832,
        3833,
        3861,
        3961,
        4247,
        4405,
        4440,
        4856,
        4894,
        5040,
        5124,
        5343,
        5358,
        5549,
        5550,
        6310,
        7191,
        8225,
        8719,
        9116,
        592,
        593,
        596,
        597,
        4888,
        6182,
        6479,
        4845,
        4846,
        7072
    ],
    "ngacang": [
        71
    ],
    "ngachang": [
        71
    ],
    "ngac’ang": [
        71
    ],
    "ngatsang": [
        71
    ],
    "ngo chang": [
        71
    ],
    "ngo": [
        71,
        628
    ],
    "ngochang": [
        71
    ],
    "ngoqchangh": [
        71
    ],
    "nl": [
        78,
        1965,
        1969,
        2006,
        2188,
        2503,
        2746,
        4323,
        5376,
        5536,
        5540,
        5842,
        5845,
        5846,
        6522,
        6769,
        7169,
        7821,
        8071,
        9007
    ],
    "netherlands": [
        1969,
        8081,
        78,
        1965,
        2006,
        2188,
        2503,
        2746,
        4323,
        5376,
        5536,
        5540,
        5842,
        5845,
        5846,
        6522,
        6769,
        7169,
        7821,
        8071,
        9007
    ],
    "nusa tadon": [
        101,
        3192
    ],
    "nusa": [
        5735,
        101,
        3192
    ],
    "nimalda": [
        104
    ],
    "nuralda": [
        104
    ],
    "ngamdo": [
        107
    ],
    "ngariba": [
        115
    ],
    "northeast": [
        120,
        3690,
        5584,
        3173,
        4239,
        5905,
        7039,
        7581,
        7986,
        8148
    ],
    "northeast pashai": [
        120
    ],
    "northeast pashayi": [
        120
    ],
    "nc": [
        121,
        222,
        319,
        356,
        402,
        571,
        1034,
        1221,
        1340,
        1474,
        1507,
        1842,
        1999,
        2451,
        2501,
        3098,
        3111,
        3319,
        3324,
        3542,
        4865,
        5050,
        5089,
        5393,
        5399,
        5400,
        5401,
        5725,
        6165,
        6206,
        6260,
        6290,
        6873,
        8033,
        8280,
        8838
    ],
    "new caledonia": [
        121,
        222,
        319,
        356,
        402,
        571,
        1034,
        1221,
        1340,
        1474,
        1507,
        1842,
        1999,
        2451,
        2501,
        3098,
        3111,
        3319,
        3324,
        3542,
        4865,
        5050,
        5089,
        5393,
        5399,
        5400,
        5401,
        5725,
        6165,
        6206,
        6260,
        6290,
        6873,
        8033,
        8280,
        8838
    ],
    "nam": [
        2247,
        2814,
        3791,
        4313,
        5293,
        5294,
        5295,
        5296,
        5297,
        5745,
        8923,
        8924,
        8925,
        8926,
        123,
        701,
        933,
        935,
        1080,
        1100,
        1481,
        1485,
        1486,
        1487,
        1529,
        1536,
        1543,
        1622,
        1680,
        2229,
        2650,
        2651,
        2883,
        2887,
        2896,
        2966,
        2977,
        2994,
        3034,
        3047,
        3048,
        3051,
        3120,
        3346,
        3419,
        3710,
        3886,
        3981,
        4002,
        4127,
        4208,
        4235,
        4302,
        4359,
        4551,
        4877,
        4941,
        4949,
        4970,
        5117,
        5402,
        5723,
        5738,
        6017,
        6019,
        6123,
        6124,
        6365,
        6457,
        6501,
        6511,
        6564,
        6582,
        6586,
        6719,
        6777,
        7163,
        7165,
        7177,
        7319,
        7401,
        7555,
        7601,
        7654,
        7740,
        7825,
        7826,
        7863,
        7865,
        7866,
        7867,
        7870,
        7871,
        7872,
        7873,
        7878,
        8078,
        8079,
        8080,
        8402,
        8481,
        9042,
        9045,
        9110
    ],
    "na": [
        5327,
        5328,
        2393,
        5678,
        2573,
        3060,
        3250,
        3525,
        4093,
        4322,
        4473,
        5620,
        5621,
        7386,
        7387,
        8819,
        135,
        1863,
        2185,
        2502,
        2928,
        3108,
        3694,
        3843,
        4006,
        4085,
        4086,
        4424,
        5300,
        5326,
        5420,
        6709,
        8052,
        8684
    ],
    "namibia": [
        5300,
        135,
        1863,
        2185,
        2502,
        2928,
        3108,
        3694,
        3843,
        4006,
        4085,
        4086,
        4424,
        5326,
        5420,
        6709,
        8052,
        8684
    ],
    "nanubae": [
        142
    ],
    "north idoma": [
        152
    ],
    "ngelima": [
        157
    ],
    "narihua": [
        172,
        7171
    ],
    "naujin sdrato": [
        177
    ],
    "naujin": [
        177
    ],
    "neo-aramaic": [
        202,
        203,
        204,
        307,
        308,
        309,
        310,
        821,
        863,
        7275,
        7277,
        7706
    ],
    "neo-syriac": [
        203
    ],
    "noshan": [
        7706,
        204,
        3094
    ],
    "nokwu": [
        257
    ],
    "namurug": [
        291
    ],
    "nga:mr:rak": [
        291
    ],
    "nga:mu:rak": [
        291
    ],
    "ngamurag": [
        291
    ],
    "nomndaa": [
        305
    ],
    "neo-western aramaic": [
        307,
        308,
        309,
        310
    ],
    "neo-western": [
        307,
        308,
        309,
        310
    ],
    "ngas": [
        317
    ],
    "naa xaracuu": [
        319
    ],
    "naa": [
        4093,
        319,
        571,
        1999,
        3542
    ],
    "nend": [
        322
    ],
    "nent": [
        322
    ],
    "no": [
        9180,
        326,
        5729,
        1179,
        7314,
        2395,
        5308,
        5590,
        5617,
        5692,
        6546,
        6770,
        6771
    ],
    "namfau": [
        327
    ],
    "nuro": [
        337,
        338
    ],
    "nyang": [
        339,
        6062,
        6063
    ],
    "ngola": [
        344
    ],
    "nembi": [
        348
    ],
    "north levantine arabic": [
        368
    ],
    "np": [
        376,
        624,
        818,
        953,
        972,
        1082,
        1278,
        1293,
        1395,
        1396,
        1459,
        1667,
        1692,
        1696,
        1834,
        1843,
        1957,
        1963,
        1967,
        1994,
        2012,
        2030,
        2105,
        2593,
        2629,
        2630,
        2637,
        2837,
        2867,
        3089,
        3345,
        3361,
        3394,
        3433,
        3439,
        3625,
        3627,
        3676,
        3684,
        3709,
        3756,
        3768,
        3781,
        3927,
        3986,
        4155,
        4176,
        4233,
        4317,
        4329,
        4400,
        4465,
        4466,
        4485,
        4537,
        4755,
        4756,
        4844,
        5042,
        5135,
        5298,
        5337,
        5385,
        5386,
        5388,
        5409,
        5410,
        5411,
        5574,
        5575,
        5641,
        5697,
        5758,
        5759,
        5760,
        5761,
        5762,
        5769,
        5891,
        6137,
        6194,
        6364,
        6454,
        6455,
        6458,
        6471,
        6475,
        6476,
        6530,
        6531,
        6678,
        6732,
        6921,
        6973,
        7034,
        7208,
        7279,
        7308,
        7367,
        7390,
        7391,
        7392,
        7450,
        7471,
        7472,
        7476,
        7481,
        7482,
        7483,
        7504,
        7550,
        7599,
        7780,
        7978,
        8064,
        8270,
        8275,
        8639,
        8750,
        8751
    ],
    "nepal": [
        5409,
        5410,
        5411,
        1843,
        3768,
        5758,
        5759,
        5760,
        5761,
        5762,
        6921,
        376,
        624,
        818,
        953,
        972,
        1082,
        1278,
        1293,
        1395,
        1396,
        1459,
        1667,
        1692,
        1696,
        1834,
        1957,
        1963,
        1967,
        1994,
        2012,
        2030,
        2105,
        2593,
        2629,
        2630,
        2637,
        2837,
        2867,
        3089,
        3345,
        3361,
        3394,
        3433,
        3439,
        3625,
        3627,
        3676,
        3684,
        3709,
        3756,
        3781,
        3927,
        3986,
        4155,
        4176,
        4233,
        4317,
        4329,
        4400,
        4465,
        4466,
        4485,
        4537,
        4755,
        4756,
        4844,
        5042,
        5135,
        5298,
        5337,
        5385,
        5386,
        5388,
        5574,
        5575,
        5641,
        5697,
        5769,
        5891,
        6137,
        6194,
        6364,
        6454,
        6455,
        6458,
        6471,
        6475,
        6476,
        6530,
        6531,
        6678,
        6732,
        6973,
        7034,
        7208,
        7279,
        7308,
        7367,
        7390,
        7391,
        7392,
        7450,
        7471,
        7472,
        7476,
        7481,
        7482,
        7483,
        7504,
        7550,
        7599,
        7780,
        7978,
        8064,
        8270,
        8275,
        8639,
        8750,
        8751
    ],
    "na’isha": [
        379
    ],
    "ndé bizaa": [
        381
    ],
    "ndé": [
        381
    ],
    "ndee biyáti'": [
        391
    ],
    "ndee": [
        391
    ],
    "ndee biyáti’": [
        391
    ],
    "nnee biyáti’": [
        391
    ],
    "nnee": [
        391
    ],
    "north akoko": [
        397
    ],
    "ninka": [
        398
    ],
    "nka": [
        398
    ],
    "northern": [
        4476,
        5677,
        6772,
        6773,
        8608,
        400,
        505,
        902,
        956,
        1544,
        1550,
        1551,
        1612,
        1613,
        1650,
        1670,
        1820,
        1932,
        2109,
        2473,
        2630,
        2980,
        2988,
        3012,
        3080,
        3688,
        3916,
        4012,
        4014,
        4111,
        4112,
        4145,
        4475,
        5343,
        5349,
        5350,
        5422,
        5466,
        5603,
        5620,
        5621,
        5695,
        5696,
        5698,
        5710,
        5718,
        5747,
        5931,
        6032,
        6097,
        6209,
        6216,
        6382,
        6429,
        6440,
        6487,
        6586,
        6646,
        7159,
        7473,
        7522,
        7742,
        7767,
        7823,
        8305,
        8493,
        8564,
        8656,
        8811,
        8816,
        8856,
        503,
        583,
        623,
        626,
        648,
        677,
        735,
        744,
        757,
        921,
        1170,
        1194,
        1259,
        1260,
        1261,
        1267,
        1716,
        1923,
        2233,
        2672,
        2883,
        2905,
        3169,
        3170,
        3744,
        3803,
        3946,
        4061,
        4062,
        4215,
        4233,
        4322,
        4524,
        4536,
        4571,
        4808,
        4918,
        4950,
        5139,
        5358,
        5565,
        5592,
        5720,
        5861,
        5862,
        5865,
        5866,
        6197,
        6358,
        6519,
        6520,
        6521,
        6522,
        6568,
        6770,
        6771,
        6786,
        7132,
        7133,
        7165,
        7175,
        7409,
        7415,
        7619,
        7649,
        7678,
        7828,
        8300,
        8646,
        8831,
        8931,
        8935,
        8986,
        9016,
        9020,
        9021,
        9022,
        9030,
        9040,
        9126,
        9146,
        9147,
        9171,
        2740,
        2741,
        2763,
        2890,
        2986,
        4007,
        4009,
        4010,
        6306,
        8038,
        8039,
        8040,
        8042,
        8043,
        1339,
        2179
    ],
    "northern alta": [
        400
    ],
    "ntogapid": [
        450
    ],
    "ntogapig": [
        450
    ],
    "najdi": [
        451
    ],
    "najdi arabic": [
        451
    ],
    "normal egyptian arabic": [
        457,
        458
    ],
    "normal": [
        457,
        458
    ],
    "nakhoda": [
        461
    ],
    "nakhona": [
        461
    ],
    "nakhota": [
        461
    ],
    "nakhóda": [
        461
    ],
    "nakhóna": [
        461
    ],
    "nakhóta": [
        461
    ],
    "nakoda": [
        461,
        7172
    ],
    "nakon": [
        461
    ],
    "nakona": [
        461
    ],
    "nakota": [
        461
    ],
    "nsari": [
        469
    ],
    "north-okpela-arhe": [
        491
    ],
    "northern cagayan negrito": [
        503
    ],
    "northern altai": [
        505
    ],
    "njao": [
        528,
        5361
    ],
    "nyao": [
        528
    ],
    "ngamiti": [
        538
    ],
    "nggamadi": [
        538
    ],
    "nggammadi": [
        538
    ],
    "ngkamadyi’": [
        538
    ],
    "negros": [
        545
    ],
    "ngerikudi": [
        550
    ],
    "nggerikudi": [
        550
    ],
    "nggirikudi": [
        550
    ],
    "nigger-ikudi": [
        550
    ],
    "nìín yěbù": [
        556
    ],
    "nìín": [
        556
    ],
    "nohon": [
        560
    ],
    "nyoyaka": [
        568
    ],
    "naa xaragure": [
        571
    ],
    "nuwu": [
        577
    ],
    "northern yemeni arabic": [
        583
    ],
    "north mesopotamian arabic": [
        585
    ],
    "nimitso": [
        598,
        8965
    ],
    "niuweiba phula": [
        598,
        8792,
        8965
    ],
    "niuweiba": [
        598,
        8792,
        8965
    ],
    "nahuatl, eastern durango": [
        602
    ],
    "nahuatl": [
        602,
        605,
        608,
        5307,
        5341,
        5343,
        5345,
        5356,
        5439,
        5447,
        5449,
        5451,
        5453,
        5454,
        5455,
        5456,
        5458,
        5459,
        5461,
        5463,
        5464,
        5465,
        5466,
        5467,
        5556,
        5645,
        5704,
        5751,
        5342
    ],
    "nahuat del este de durango": [
        602
    ],
    "nahuat": [
        6271,
        602,
        605,
        5465
    ],
    "nahuatl, western durango": [
        605
    ],
    "nahuat del occidente en durango y nayarit": [
        605
    ],
    "nayarit": [
        605
    ],
    "nahuatl, highland puebla": [
        608
    ],
    "nahuatlahtolli": [
        608,
        5459
    ],
    "náhuat de la sierra de puebla": [
        608
    ],
    "náhuat": [
        608,
        5341,
        5458,
        5465
    ],
    "náhuatl": [
        5307,
        5341,
        5343,
        5356,
        5439,
        5449,
        5454,
        5455,
        5456,
        5459,
        5464,
        5465,
        5466,
        5467,
        5556,
        5645,
        5704,
        608,
        5463
    ],
    "nubaca": [
        614
    ],
    "nu baca": [
        614
    ],
    "nu": [
        2539,
        3289,
        614,
        2792,
        3738,
        8738,
        1245,
        5737,
        7839,
        8735,
        2190,
        5486
    ],
    "nanga": [
        5821,
        8670,
        8671,
        8672,
        615
    ],
    "northern barasano": [
        623
    ],
    "northern mbene": [
        626
    ],
    "nge": [
        628,
        5438
    ],
    "nguu": [
        628,
        5434
    ],
    "ngwa": [
        628
    ],
    "nga-kejom": [
        644
    ],
    "northern bobo madaré": [
        648
    ],
    "ngoobechop": [
        650
    ],
    "nama": [
        5587,
        7580,
        660,
        661,
        4215,
        5300
    ],
    "north babar": [
        663
    ],
    "nadot’en": [
        677
    ],
    "nat’oot’en": [
        677
    ],
    "nedut’en": [
        677
    ],
    "northern carrier": [
        677
    ],
    "nyam": [
        5570,
        7064,
        723
    ],
    "northern bété": [
        735
    ],
    "northern bai": [
        744,
        4215
    ],
    "nchufie": [
        752
    ],
    "ndélé": [
        754
    ],
    "nyele": [
        754
    ],
    "ngmalba": [
        757
    ],
    "nmalba": [
        757
    ],
    "northern birifor": [
        757
    ],
    "nanqa poroja": [
        771
    ],
    "nanqa": [
        771
    ],
    "noefoor": [
        832
    ],
    "noefoorsch": [
        832
    ],
    "nufoor": [
        832
    ],
    "naga": [
        3395,
        3615,
        3691,
        4470,
        4567,
        5288,
        5312,
        5314,
        5317,
        5329,
        5353,
        5354,
        5494,
        5496,
        5500,
        5501,
        5502,
        5512,
        5516,
        5518,
        5519,
        5520,
        5554,
        5561,
        5565,
        5566,
        5569,
        5577,
        5578,
        5597,
        5598,
        5603,
        5606,
        5607,
        5608,
        5643,
        5644,
        5647,
        5649,
        5658,
        5660,
        5666,
        5669,
        5681,
        5693,
        5701,
        5702,
        5703,
        5722,
        5776,
        5817,
        6221,
        6392,
        7713,
        7813,
        7963,
        8803,
        843,
        844,
        4403,
        4404,
        6355
    ],
    "nai": [
        848,
        1235,
        6244,
        7524
    ],
    "nangnda": [
        881
    ],
    "ningebal": [
        884
    ],
    "nyakyak": [
        886
    ],
    "nkom": [
        896
    ],
    "northern sorsoganon": [
        902
    ],
    "northern sorsogon": [
        902
    ],
    "nfua": [
        909
    ],
    "nki": [
        909
    ],
    "niitsipowahsin": [
        911,
        912
    ],
    "noir": [
        911,
        912,
        933,
        934,
        935
    ],
    "nuxalk": [
        914
    ],
    "northern taungthu": [
        921
    ],
    "ngoya": [
        936
    ],
    "notre": [
        939
    ],
    "nootre": [
        939
    ],
    "northern betsimisaraka malagasy": [
        956
    ],
    "ne": [
        2986,
        962,
        1872,
        1873,
        1874,
        2361,
        2374,
        2452,
        2486,
        2488,
        2493,
        2879,
        2880,
        3503,
        3504,
        3943,
        7379,
        7380,
        7381,
        7435,
        7436,
        7491,
        7492,
        7594,
        7595,
        7596,
        7832
    ],
    "niger": [
        2486,
        2488,
        2493,
        2487,
        962,
        1872,
        1873,
        1874,
        2361,
        2374,
        2452,
        2879,
        2880,
        3503,
        3504,
        3943,
        7379,
        7380,
        7381,
        7435,
        7436,
        7491,
        7492,
        7594,
        7595,
        7596,
        7832
    ],
    "ndowe": [
        979,
        5732
    ],
    "naka": [
        984
    ],
    "noho": [
        984
    ],
    "noku": [
        984
    ],
    "njan": [
        1004
    ],
    "ndüü böngö": [
        1018
    ],
    "ndüü": [
        1018
    ],
    "northwest marind": [
        1045
    ],
    "northwest": [
        2678,
        4820,
        5205,
        3177,
        1045,
        2539
    ],
    "njwande": [
        1099
    ],
    "nakhorn": [
        1106
    ],
    "nuristani": [
        1122,
        6294
    ],
    "ngen": [
        2712,
        1123,
        7151
    ],
    "nsose": [
        1123
    ],
    "nswase": [
        1123
    ],
    "nswose": [
        1123
    ],
    "ngoe": [
        1135,
        1242
    ],
    "nkoosi": [
        1135
    ],
    "nkosi": [
        1135
    ],
    "ngong": [
        5440,
        5633,
        1146
    ],
    "nada": [
        1157
    ],
    "nong": [
        9047,
        9048,
        1158,
        5745,
        9181,
        1535,
        1536
    ],
    "ntau": [
        1168
    ],
    "northern mongolian": [
        1170,
        1259,
        1260,
        1261,
        1267
    ],
    "ntcham": [
        1173,
        1174
    ],
    "ncham": [
        1173,
        1174
    ],
    "ncam": [
        1173,
        1174
    ],
    "northern bullom": [
        1194
    ],
    "ndop-bamunka": [
        1208
    ],
    "ngiemekohke": [
        1208
    ],
    "niemeng": [
        1208
    ],
    "namosi-naitasiri-serua": [
        1222
    ],
    "namosi-naitaasiri-seerua": [
        1222
    ],
    "ngnai": [
        1235
    ],
    "ngala": [
        1254,
        4419,
        5670,
        5727,
        6174
    ],
    "northeastern mongolian": [
        1267
    ],
    "northeastern": [
        8589,
        1859,
        2487,
        6051,
        6093,
        7772,
        1267,
        2973,
        2974,
        2975,
        3722,
        5403,
        5444,
        5995,
        6384,
        6758,
        7274,
        8113,
        9129,
        2486,
        2488
    ],
    "njadu": [
        1274
    ],
    "nyadu": [
        1274
    ],
    "ngur": [
        1278
    ],
    "north agaw": [
        1284,
        1285
    ],
    "nyuwǎ ɓúúrák": [
        1290
    ],
    "nyuwǎ": [
        1290
    ],
    "nononke": [
        1300,
        1301
    ],
    "nucum": [
        1302
    ],
    "nicaragua english creole": [
        1307
    ],
    "nicaragua": [
        1307,
        5352,
        2276,
        4809,
        4969,
        5114,
        6540,
        7201,
        7955,
        8732
    ],
    "nicaragua creole english": [
        1307
    ],
    "ni": [
        5755,
        7524,
        8908,
        1307,
        2276,
        4809,
        4969,
        5114,
        5352,
        6540,
        7201,
        7955,
        8732
    ],
    "naami": [
        1318
    ],
    "nivaclé": [
        1335
    ],
    "nivaklé": [
        1335
    ],
    "northern mariana islands": [
        1339,
        2179,
        7678
    ],
    "nicobarese, car": [
        1344
    ],
    "nicobarese": [
        1344,
        5334,
        5335,
        5477
    ],
    "nicobar": [
        1344,
        5334,
        5335
    ],
    "nicobara": [
        1344,
        5477
    ],
    "nyahkur": [
        1361
    ],
    "niakuol": [
        1361
    ],
    "niakuoll": [
        1361
    ],
    "nyah kur": [
        1361
    ],
    "nyah": [
        1361,
        5408
    ],
    "nyakur": [
        1361
    ],
    "ndazora": [
        1362
    ],
    "nokchiin muott": [
        1405,
        1406,
        1407
    ],
    "nokchiin": [
        1405,
        1406,
        1407
    ],
    "nokhchi": [
        1405,
        1406,
        1407
    ],
    "nokhchiin": [
        1405,
        1406,
        1407
    ],
    "nfachara": [
        1426
    ],
    "nuadhu": [
        1427
    ],
    "nkore": [
        1435
    ],
    "nkore-kiga": [
        1435
    ],
    "ngacha": [
        1436
    ],
    "new cham": [
        1478,
        1479,
        1480
    ],
    "neu-pommern": [
        1506,
        2565
    ],
    "nenqayni ch’ih": [
        1515
    ],
    "nenqayni": [
        1515
    ],
    "nedu": [
        1520,
        1521
    ],
    "na’klallam": [
        1523
    ],
    "ngan": [
        2712,
        7878,
        1529,
        4567
    ],
    "northern qiang": [
        1544
    ],
    "northern guangxi": [
        1550,
        1551
    ],
    "northern ping chinese": [
        1550,
        1551
    ],
    "northern pinghua": [
        1550,
        1551
    ],
    "ngawn": [
        1557
    ],
    "ngawn chin": [
        1557
    ],
    "ngon": [
        1557
    ],
    "ngorn": [
        1557
    ],
    "nxa’amxcin": [
        1570
    ],
    "numinu": [
        1571
    ],
    "nʉmʉ tekwapʉ": [
        1571
    ],
    "nʉmʉ": [
        1571
    ],
    "neo-egyptian": [
        1574,
        1575,
        1576
    ],
    "nanti": [
        1582
    ],
    "ngiba": [
        1583,
        6045,
        6046,
        6060,
        6251,
        6265,
        6277
    ],
    "ngigua": [
        6197,
        6251,
        6277,
        1583,
        6045,
        6046,
        6060
    ],
    "ngiwa": [
        1583,
        6045,
        6046,
        6197,
        6251,
        6277
    ],
    "nr": [
        1588,
        2189,
        5282
    ],
    "nauru": [
        5282,
        1588,
        2189
    ],
    "noumou": [
        1590
    ],
    "noumoukan": [
        1590
    ],
    "numu": [
        6032,
        1590
    ],
    "nīhithawīwin": [
        1596,
        1597
    ],
    "nehiyaw": [
        1610,
        1611
    ],
    "nēhiyawēwin": [
        1610,
        1611
    ],
    "nord-est": [
        1612,
        1613
    ],
    "northern east cree": [
        1612,
        1613
    ],
    "nayar": [
        1615
    ],
    "naáyeri nyuuca": [
        1615
    ],
    "naáyeri": [
        1615
    ],
    "nyuuca": [
        1615
    ],
    "naáyeri niuka": [
        1615
    ],
    "niuka": [
        1615
    ],
    "northern ohlone": [
        1650
    ],
    "noroeste": [
        1665,
        4796,
        4819,
        5205,
        6051
    ],
    "northern catanduanes bicolano": [
        1670
    ],
    "northern catanduanes bikol": [
        1670
    ],
    "nomole": [
        1686
    ],
    "ngao fon": [
        1691
    ],
    "ngao": [
        1691
    ],
    "nacional": [
        1702,
        4807
    ],
    "nghwele": [
        1705
    ],
    "ngh’wele": [
        1705
    ],
    "ngwele": [
        1705
    ],
    "ng’were": [
        1705
    ],
    "nhwele": [
        1705
    ],
    "nwele": [
        1705
    ],
    "nopala": [
        1710
    ],
    "nopala chatino": [
        1710
    ],
    "northern chatino": [
        1716
    ],
    "nduupa": [
        1725
    ],
    "nyala-lagowa": [
        1730
    ],
    "noumandan": [
        1747
    ],
    "numadaw": [
        1747
    ],
    "nyiyo daddi̱ya": [
        1749
    ],
    "nyiyo": [
        1749
    ],
    "nda dia": [
        1749
    ],
    "nda": [
        1749,
        5126
    ],
    "najamba-kindige dogon": [
        1764
    ],
    "najamba-kindige": [
        1764
    ],
    "negerhollands": [
        1770
    ],
    "negerhollandsch": [
        1770
    ],
    "negrodutch": [
        1770
    ],
    "nemec": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "nemetskiy": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "niemiec": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "njemački": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "német": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "němec": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "ndem": [
        1803,
        5323
    ],
    "ndengese": [
        1812
    ],
    "nkutu": [
        5533,
        1812
    ],
    "northern dagaare": [
        1820
    ],
    "northern dagara": [
        1820
    ],
    "nubian": [
        5935,
        1822,
        1823,
        1824,
        2095,
        4687,
        8572,
        8573,
        8574
    ],
    "ndra’ngith": [
        1828
    ],
    "ndra'ngith": [
        1828
    ],
    "ndra?angid": [
        1828
    ],
    "ndrag’ngith": [
        1828
    ],
    "ndraˀangit": [
        1828
    ],
    "ntra’angith": [
        1828
    ],
    "ntʳaˀŋit̯": [
        1828
    ],
    "nawp": [
        1832
    ],
    "northeastern dinka": [
        1859
    ],
    "nile": [
        1859
    ],
    "northwestern": [
        8052,
        8609,
        1864,
        2348,
        3587,
        5686,
        5861,
        5862,
        7599,
        4890,
        4891,
        5115,
        5989,
        6306,
        6749,
        7167,
        9120,
        9121,
        9143,
        5889
    ],
    "northwestern dinka": [
        1864
    ],
    "ngaliwurru": [
        1871
    ],
    "ngaigungo": [
        1875
    ],
    "ndjébbana": [
        1877
    ],
    "ndjuká": [
        1878,
        1879
    ],
    "ndyuka": [
        1878,
        1879
    ],
    "ndyuka tongo": [
        1878,
        1879
    ],
    "nenge": [
        1878,
        1879
    ],
    "nenge tongo": [
        1878,
        1879
    ],
    "nengee": [
        1878,
        1879
    ],
    "nengee tongo": [
        1878,
        1879
    ],
    "njuká": [
        1878,
        1879
    ],
    "nordost-celebes": [
        1888
    ],
    "ndendeule": [
        1916
    ],
    "ndendeuli": [
        1916
    ],
    "ndrulo": [
        1923
    ],
    "ndralo": [
        1923
    ],
    "ndrŭló": [
        1923
    ],
    "ndukpa": [
        1923
    ],
    "northern lendu": [
        1923
    ],
    "northern dong": [
        1932
    ],
    "nomai": [
        1949
    ],
    "ndmpo": [
        1951
    ],
    "ninhou": [
        1955
    ],
    "north damar": [
        1961
    ],
    "niedersorbisch": [
        1968
    ],
    "ngt": [
        1969
    ],
    "nederlandse gebarentaal": [
        1969
    ],
    "nederlandse": [
        1969
    ],
    "nitinaht": [
        1982
    ],
    "nitinat": [
        1982
    ],
    "naa drubea": [
        1999
    ],
    "naa dubea": [
        1999
    ],
    "ndumbea": [
        1999
    ],
    "nraa drubea": [
        1999
    ],
    "nraa": [
        1999
    ],
    "nyag dii": [
        2011
    ],
    "nyag": [
        2011
    ],
    "ngarlkajie": [
        2043
    ],
    "nulibié": [
        2084
    ],
    "nulibie": [
        2084
    ],
    "neo-hellenic": [
        2090,
        2091,
        2093
    ],
    "nding": [
        2096
    ],
    "newahang": [
        2105,
        6458
    ],
    "newahang jimi": [
        2105,
        6458
    ],
    "newang": [
        2105,
        6458
    ],
    "newange rai": [
        2105,
        6458
    ],
    "newange": [
        2105,
        6458
    ],
    "northern emberá": [
        2109
    ],
    "nevis": [
        2171
    ],
    "nf": [
        2186,
        6149
    ],
    "norfolk island": [
        2186,
        6149
    ],
    "norfolk": [
        2186,
        6149
    ],
    "niue": [
        5486,
        2190
    ],
    "nz": [
        2191,
        4790,
        5818
    ],
    "new zealand": [
        2191,
        4790,
        5818
    ],
    "nung ven": [
        2229
    ],
    "nung": [
        5745,
        2229,
        5737,
        6477,
        6478,
        6479,
        6480,
        6481,
        6482,
        9181,
        9184,
        9188,
        8923,
        8924,
        8925,
        8926
    ],
    "nungven": [
        2229
    ],
    "northern lengua": [
        2233
    ],
    "ngene": [
        2235
    ],
    "nam eromaga": [
        2247
    ],
    "nuru": [
        2249
    ],
    "nafsan": [
        2250
    ],
    "nyagrong-minyag": [
        2251
    ],
    "north alaskan inuktitut": [
        2291
    ],
    "north alaskan inupiaq": [
        2291
    ],
    "north alaskan inupiat": [
        2291
    ],
    "north alaskan inupiatun": [
        2291
    ],
    "north alaskan iñupiaq": [
        2291
    ],
    "niten": [
        2314
    ],
    "new persian": [
        2329
    ],
    "namo me": [
        2331
    ],
    "namo": [
        5227,
        2331
    ],
    "namo aporo": [
        2331
    ],
    "namome": [
        2331
    ],
    "nosa fala": [
        2346
    ],
    "nosa": [
        2346
    ],
    "northwestern fars": [
        2348
    ],
    "nobiin": [
        2383,
        2384,
        2385
    ],
    "north finnish": [
        2391,
        2395
    ],
    "na vosa vakaviti": [
        2393
    ],
    "norway": [
        2395,
        5308,
        5590,
        5617,
        5692,
        6546,
        6770,
        6771
    ],
    "nqlispélišcn": [
        2396
    ],
    "north fali": [
        2399
    ],
    "nufi": [
        2403
    ],
    "nùfī": [
        2403
    ],
    "nordfriesisch": [
        2473
    ],
    "northern frisian": [
        2473
    ],
    "nagapelta": [
        2479,
        2480
    ],
    "northeastern burkina faso fulfulde": [
        2486,
        2487,
        2488
    ],
    "nigerian": [
        5689,
        2497,
        2498,
        6077
    ],
    "nigerian fulfulde": [
        2497,
        2498
    ],
    "ngabre": [
        2509
    ],
    "narake": [
        2522
    ],
    "nobonob": [
        2533
    ],
    "nobanob": [
        2533
    ],
    "nobnob": [
        2533
    ],
    "nupanob": [
        2533
    ],
    "nu gbaya": [
        2539,
        2792
    ],
    "nord-ouest": [
        2539
    ],
    "northwest gbaya": [
        2539
    ],
    "niksek": [
        2543
    ],
    "nkwa": [
        2563
    ],
    "ngondi": [
        2583,
        5371
    ],
    "ngundi": [
        5371,
        2583
    ],
    "ngba geme": [
        2608
    ],
    "ngba": [
        2608
    ],
    "nggao": [
        2617
    ],
    "northern ghale": [
        2630
    ],
    "noo": [
        2636
    ],
    "noowidal": [
        2644
    ],
    "north giziga": [
        2652
    ],
    "nass-gitksan": [
        2653
    ],
    "noot": [
        2661
    ],
    "ngutuk": [
        2661
    ],
    "nil-can-cone-deets": [
        2661
    ],
    "ngbanyito": [
        2662,
        2663
    ],
    "ndai": [
        2669
    ],
    "nar": [
        5641,
        2671,
        4093
    ],
    "nhang": [
        6062,
        6063,
        2671
    ],
    "narr": [
        2671
    ],
    "northern kpele": [
        2672
    ],
    "nanai": [
        2677
    ],
    "nanaj": [
        2677
    ],
    "nanay": [
        2677
    ],
    "northwest pashai": [
        2678
    ],
    "northwest pashayi": [
        2678
    ],
    "ngura": [
        2682,
        3326
    ],
    "ngongosila": [
        2689
    ],
    "ngbo": [
        2702
    ],
    "ngangam": [
        2709
    ],
    "nbangam": [
        2709
    ],
    "ngangan": [
        2709
    ],
    "ngain": [
        2712,
        5632
    ],
    "ngin": [
        2712
    ],
    "nguin": [
        2712
    ],
    "ngɛn": [
        2712
    ],
    "nomad": [
        2732,
        3737,
        6978
    ],
    "nand": [
        2734
    ],
    "ngobo": [
        2750
    ],
    "ngobu": [
        2750
    ],
    "nyar": [
        2761,
        2762
    ],
    "nema": [
        2791
    ],
    "noematiké": [
        2794
    ],
    "namdrik": [
        2814
    ],
    "nam trik": [
        2814
    ],
    "nankani": [
        2819
    ],
    "ninkare": [
        2819
    ],
    "ninkarsé": [
        2819
    ],
    "ninkãrɛ": [
        2819
    ],
    "nankam": [
        2819
    ],
    "nankana": [
        2819
    ],
    "nganitjidi": [
        2840
    ],
    "ngannityiddi": [
        2840
    ],
    "n-batto": [
        2841
    ],
    "nglwa": [
        2841
    ],
    "ngwaa móò": [
        2847
    ],
    "ngwaa": [
        2847
    ],
    "narisati": [
        2853
    ],
    "narsati": [
        2853
    ],
    "ngäbere": [
        2865
    ],
    "ngobere": [
        2865
    ],
    "ngäbe": [
        2865
    ],
    "nove": [
        2865
    ],
    "noi": [
        2883,
        6129
    ],
    "nnkhhn": [
        2883
    ],
    "northern vietnamese sign language": [
        2883
    ],
    "nnkhhp": [
        2887
    ],
    "northern kwakiutl": [
        2905
    ],
    "nya huba": [
        2912
    ],
    "nya": [
        2912,
        5481,
        8866,
        5620,
        5621
    ],
    "naura": [
        2929
    ],
    "nga la": [
        2968
    ],
    "nga": [
        2968,
        5330,
        3935
    ],
    "northeastern dian miao": [
        2973,
        2974,
        2975
    ],
    "northeastern yunnan miao": [
        2973,
        2974,
        2975
    ],
    "nghia lo": [
        2977
    ],
    "nghia": [
        2977
    ],
    "northern huishui hmong": [
        2980
    ],
    "northern huishui miao": [
        2980
    ],
    "northern east guizhou miao": [
        2986
    ],
    "northern hmu": [
        2986
    ],
    "northern mashan hmong": [
        2988
    ],
    "northern mashan miao": [
        2988
    ],
    "nzi": [
        2997,
        2998
    ],
    "nhi": [
        3004
    ],
    "ní": [
        3004
    ],
    "njua": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "nzhua": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "nzhuab": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "ntsua": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "northern hindko": [
        3012
    ],
    "nnkhtphcm": [
        3034
    ],
    "niwer mil": [
        3046
    ],
    "niwer": [
        3046
    ],
    "ndrang": [
        3050
    ],
    "ndong": [
        3050
    ],
    "ndou": [
        3050
    ],
    "nhirrpi": [
        3052
    ],
    "noaiko-muína": [
        3066
    ],
    "northern guiyang hmong": [
        3080
    ],
    "northern guiyang miao": [
        3080
    ],
    "na:tinixwe mixine:whe’": [
        3085
    ],
    "natinixwe": [
        3085
    ],
    "nipode": [
        3093
    ],
    "nipode huitoto": [
        3093
    ],
    "nipode witoto": [
        3093
    ],
    "nüpode": [
        3093
    ],
    "nüpode huitoto": [
        3093
    ],
    "ngwané": [
        3101
    ],
    "ngepma kwundi": [
        3112
    ],
    "ngepma": [
        3112
    ],
    "nabaloi": [
        3121
    ],
    "nyidu": [
        3128
    ],
    "nuosu": [
        3169,
        3170
    ],
    "northern yi": [
        3169,
        3170
    ],
    "nosu": [
        3169,
        3170
    ],
    "nosu yi": [
        3169,
        3170
    ],
    "northeast central ijo": [
        3173
    ],
    "nembe-akassa": [
        3176
    ],
    "northwest alaska inupiat": [
        3177
    ],
    "ngulak": [
        3190
    ],
    "ng’ateus": [
        3190
    ],
    "ng’ateuso": [
        3190
    ],
    "naung ma": [
        3225
    ],
    "naung": [
        3225
    ],
    "nkarigwe": [
        3237
    ],
    "nnerigwe": [
        3237
    ],
    "nyango": [
        3237
    ],
    "nkem-nkum": [
        3252
    ],
    "noogoon": [
        3316
    ],
    "new caledonian javanese": [
        3319
    ],
    "nangu": [
        3323,
        5436
    ],
    "nhangu": [
        3323
    ],
    "njawe": [
        3324
    ],
    "nafusi": [
        3330
    ],
    "nefusi": [
        3330
    ],
    "njikum": [
        3334
    ],
    "nnwa’ dzâ": [
        3351
    ],
    "nnwa’": [
        3351
    ],
    "ngbee": [
        3355
    ],
    "ngomba": [
        3359,
        5425
    ],
    "ndaꞌa": [
        3359
    ],
    "ndaa": [
        3359
    ],
    "nda’a": [
        3359
    ],
    "nakare": [
        3365
    ],
    "ngile": [
        3387
    ],
    "nepali": [
        5385,
        5386,
        5387,
        5388,
        3944,
        5697,
        3394
    ],
    "naga, makuri": [
        3395
    ],
    "ns": [
        3425
    ],
    "nsg": [
        3425
    ],
    "nihon shuwa": [
        3425
    ],
    "nihon": [
        3425
    ],
    "nihon shuwa gengo": [
        3425
    ],
    "ngadjuri": [
        3431
    ],
    "ngadhuri": [
        3431
    ],
    "ngadluri": [
        3431
    ],
    "ngadyuri": [
        3431
    ],
    "ngaluri": [
        3431
    ],
    "ngarluri": [
        3431
    ],
    "nuquencaibo": [
        3473
    ],
    "neogulada": [
        3482
    ],
    "nzáà kã́rĩ́": [
        3490
    ],
    "nzáà": [
        3490
    ],
    "nat": [
        3499
    ],
    "natra": [
        3499
    ],
    "nzuhwi": [
        3505
    ],
    "ngkâlmpw": [
        3509
    ],
    "ngkolmpu": [
        3509,
        3648
    ],
    "ngkontar ngkolmpu": [
        3509
    ],
    "ngkontar": [
        3509
    ],
    "ngkâlmpw kanum": [
        3509
    ],
    "nubi": [
        3519
    ],
    "nubama": [
        3522
    ],
    "nyima": [
        3522,
        5795
    ],
    "ng’akarimojong": [
        3541
    ],
    "ngakarimojong": [
        3541
    ],
    "ngakarimojongo": [
        3541
    ],
    "ng’akaramojong": [
        3541
    ],
    "n’karamojong": [
        3541
    ],
    "numèè": [
        3542
    ],
    "naa numee": [
        3542
    ],
    "numee": [
        3542
    ],
    "naa-wee": [
        3542
    ],
    "nikyob-nindem": [
        3546
    ],
    "ninkyob-nindem": [
        3546
    ],
    "nyingwom": [
        3555
    ],
    "nyiwom": [
        3555
    ],
    "northwestern kolami": [
        3587
    ],
    "nonstandard": [
        8675,
        3598,
        3599,
        8669
    ],
    "naga, kharam": [
        3615
    ],
    "niino mo-di": [
        3632
    ],
    "niino": [
        3632
    ],
    "nafarpi": [
        3634
    ],
    "nagramadu": [
        3634
    ],
    "nefarpi": [
        3634
    ],
    "neferipi": [
        3634
    ],
    "nden": [
        3635
    ],
    "nhuon": [
        3645,
        3646
    ],
    "nkumbi": [
        3664
    ],
    "ngumbi": [
        3664,
        5732
    ],
    "nkhumbi": [
        3664
    ],
    "nirere": [
        3672
    ],
    "nisel": [
        3676
    ],
    "nishel kham": [
        3676
    ],
    "nishel": [
        3676
    ],
    "nisi": [
        8909,
        3676,
        5509,
        5510
    ],
    "nisi kham": [
        3676
    ],
    "northern zaza": [
        3688
    ],
    "northeast kiwai": [
        3690
    ],
    "naga, khiamniungan": [
        3691
    ],
    "nokaw": [
        3691
    ],
    "northeastern pwo karen": [
        3722
    ],
    "northern sagara": [
        3744
    ],
    "nkoxo": [
        3745
    ],
    "nahane": [
        3762
    ],
    "nahani": [
        3762
    ],
    "nukna": [
        3784
    ],
    "nasorun ta uluveu": [
        3786
    ],
    "nasorun": [
        3786
    ],
    "nbundu": [
        3793
    ],
    "north mbundu": [
        3793
    ],
    "n’bundo": [
        3793
    ],
    "northern kalinga": [
        3803
    ],
    "north konkan": [
        3832,
        3833,
        3861
    ],
    "ngok pa": [
        3838,
        3839
    ],
    "ngok": [
        3838,
        3839
    ],
    "neng den": [
        3879
    ],
    "neng": [
        3879
    ],
    "nyatso": [
        3884
    ],
    "nyonyo": [
        3884
    ],
    "nymylan": [
        3896
    ],
    "nakrehé": [
        3914
    ],
    "northern kissi": [
        3916
    ],
    "nepali kurux": [
        3944
    ],
    "northern krahn": [
        3946
    ],
    "ngar": [
        3949
    ],
    "nggarna": [
        3949
    ],
    "new britain language": [
        3957
    ],
    "north middle franconian": [
        3961
    ],
    "naama": [
        3971
    ],
    "nora": [
        5676,
        3974
    ],
    "nubri": [
        3986
    ],
    "niinati": [
        3990
    ],
    "ninatie": [
        3990
    ],
    "north kati": [
        3990
    ],
    "north moejoe": [
        3990
    ],
    "north muyu": [
        3990
    ],
    "ndrugul": [
        3994
    ],
    "nuakata": [
        4017
    ],
    "nuevo": [
        4058
    ],
    "northern bwe": [
        4061,
        4062
    ],
    "nyaa báà": [
        4074
    ],
    "nyaa": [
        4074
    ],
    "naibedj": [
        4077
    ],
    "namatota": [
        4080
    ],
    "namatote": [
        4080
    ],
    "náà": [
        4093
    ],
    "northern khmer": [
        4111,
        4112
    ],
    "ngindere": [
        4144
    ],
    "northern binukidnon": [
        4145
    ],
    "nkuraeng": [
        4164,
        5531
    ],
    "nkurange": [
        4164,
        5531
    ],
    "nzák kàráng": [
        4177
    ],
    "nzák": [
        4177
    ],
    "northern lorung": [
        4233
    ],
    "northeast barito": [
        4239
    ],
    "north buru": [
        4247
    ],
    "noniali": [
        4251
    ],
    "nuniali": [
        4251
    ],
    "nomaande": [
        4277
    ],
    "nɔmaándɛ́": [
        4277
    ],
    "noomaante": [
        4277
    ],
    "numaand": [
        4277
    ],
    "numand": [
        4277
    ],
    "nɔmaántɛ́": [
        4277
    ],
    "nünpa": [
        4280,
        4281
    ],
    "nanimba pii": [
        4282
    ],
    "nanimba": [
        4282
    ],
    "nova": [
        4294,
        4295,
        5699,
        6038
    ],
    "neverver": [
        4304
    ],
    "nevwervwer": [
        4304
    ],
    "namen": [
        4322
    ],
    "northern lahu": [
        4322
    ],
    "nyindrou": [
        4327
    ],
    "nyada": [
        4327
    ],
    "namasa": [
        4331
    ],
    "nigbi": [
        4331
    ],
    "nigwi": [
        4331
    ],
    "nongena kor": [
        4378
    ],
    "nongena": [
        4378
    ],
    "ngaimbom": [
        4385
    ],
    "nakanamanga": [
        4388
    ],
    "north efate": [
        4388
    ],
    "nonda": [
        4405
    ],
    "north pentecost language": [
        4405
    ],
    "north raga": [
        4405
    ],
    "ndzungle": [
        4410
    ],
    "ndzungli": [
        4410
    ],
    "njungene": [
        4410
    ],
    "nsungali": [
        4410
    ],
    "nsungli": [
        4410
    ],
    "nsungni": [
        4410
    ],
    "nsaw": [
        4435
    ],
    "nsho’": [
        4435
    ],
    "nso": [
        4435
    ],
    "nso’": [
        4435
    ],
    "nungurama nyuar": [
        4436
    ],
    "nungurama": [
        4436
    ],
    "nyuar": [
        4436
    ],
    "nunguda": [
        4436
    ],
    "nungura": [
        4436
    ],
    "nunguraba": [
        4436
    ],
    "north loloda": [
        4440
    ],
    "narim": [
        4446
    ],
    "nariim": [
        4446
    ],
    "nguru": [
        4453,
        5431,
        5434
    ],
    "nabe": [
        4457
    ],
    "ndroku": [
        4458
    ],
    "naga, long phuri": [
        4470
    ],
    "nyam-pelayo": [
        4474
    ],
    "northern luri": [
        4476,
        4475
    ],
    "ngandalagarak": [
        4478
    ],
    "ngwullaro": [
        4484
    ],
    "nagi": [
        4486
    ],
    "northern luba": [
        4524
    ],
    "northern lushootseed": [
        4536
    ],
    "northern puget sound salish": [
        4536
    ],
    "naman": [
        4566,
        5300
    ],
    "netensal": [
        4566
    ],
    "naga, lainong": [
        4567
    ],
    "northern highland mazatec": [
        4571
    ],
    "nochixtlan": [
        4572
    ],
    "natakan": [
        4575
    ],
    "ntaxjo": [
        4581
    ],
    "nne nangui ngaxni": [
        4590
    ],
    "nne": [
        4590
    ],
    "nangui": [
        4590
    ],
    "ngaxni": [
        4590
    ],
    "ngmamperli": [
        4596,
        4597
    ],
    "nmampurli": [
        4596,
        4597
    ],
    "north moluccan malay": [
        4598
    ],
    "nadëb": [
        4608
    ],
    "nadeb macu": [
        4608
    ],
    "nadeb": [
        4608
    ],
    "nadöb": [
        4608
    ],
    "nadöbö": [
        4608
    ],
    "nukak makú": [
        4616
    ],
    "nukak": [
        4616
    ],
    "niagantsi": [
        4626
    ],
    "nepoye": [
        4631
    ],
    "njowe": [
        4644
    ],
    "njowi": [
        4644
    ],
    "nor": [
        4645,
        5106,
        5266
    ],
    "nɛ́mangbɛtʉ": [
        4661
    ],
    "nemangbetu": [
        4661
    ],
    "negam": [
        4685
    ],
    "nuyoo": [
        4686
    ],
    "nuyoo mixtec": [
        4686
    ],
    "nenaya": [
        4700
    ],
    "nengaya": [
        4700
    ],
    "nineia": [
        4700
    ],
    "nkwen": [
        4711
    ],
    "naki": [
        4713
    ],
    "njeyibah": [
        4713
    ],
    "nkap": [
        4713
    ],
    "ndara": [
        4717,
        4718
    ],
    "north mofu": [
        4720
    ],
    "ntәm": [
        4722
    ],
    "ndjak": [
        4731
    ],
    "ndyak": [
        4731
    ],
    "nokki": [
        4734
    ],
    "nyasa": [
        4759,
        4984,
        4823,
        7643
    ],
    "ngaaka": [
        4776
    ],
    "nga’ka": [
        4776
    ],
    "nyky": [
        4787
    ],
    "new zealand maori": [
        4790
    ],
    "neo-mandaic": [
        4795
    ],
    "northern nochixtlán mixtec": [
        4808
    ],
    "nochixtlán": [
        5229,
        4808,
        5124
    ],
    "northwest maidu": [
        4820
    ],
    "nákum": [
        4820
    ],
    "nyanza": [
        4823
    ],
    "nihang": [
        4840
    ],
    "north macedonia": [
        4845,
        4846,
        7072
    ],
    "nondi": [
        4848
    ],
    "north makaa": [
        4856
    ],
    "ngwai mungàn": [
        4860
    ],
    "ngwai": [
        4860,
        5303
    ],
    "ndáhví": [
        4864
    ],
    "nambas": [
        4885,
        5562,
        5582
    ],
    "northwestern maninka": [
        4890,
        4891
    ],
    "north malaita": [
        4894
    ],
    "na’ahai": [
        4897,
        7010
    ],
    "naha'ai": [
        4897
    ],
    "nan": [
        5293,
        5294,
        5295,
        5296,
        5297,
        4902,
        4903,
        4904
    ],
    "north ambrym": [
        4907
    ],
    "nooka dora": [
        4911
    ],
    "nooka": [
        4911
    ],
    "nuka-dora": [
        4911
    ],
    "northern miao": [
        4918,
        5139
    ],
    "numaala": [
        4920
    ],
    "numala": [
        4920
    ],
    "neenoá": [
        4921
    ],
    "neenöa": [
        4921
    ],
    "naba": [
        4939,
        5287,
        5298
    ],
    "ndɨ̧ mundàni": [
        4940
    ],
    "ndɨ̧": [
        4940
    ],
    "northern fujian": [
        4950
    ],
    "northern min": [
        4950
    ],
    "ngolak-wonga": [
        4985
    ],
    "ngolokwangga": [
        4985
    ],
    "ngulukwongga": [
        4985
    ],
    "nguluwongga": [
        4985
    ],
    "ngarrabadji": [
        4986
    ],
    "naone": [
        5040
    ],
    "north maewo": [
        5040
    ],
    "nomoi": [
        5051
    ],
    "niopheng": [
        5054,
        5055
    ],
    "niopreng": [
        5054,
        5055
    ],
    "north marquesan": [
        5057
    ],
    "nohya sign language": [
        5076
    ],
    "nohya": [
        5076
    ],
    "nor-murik lakes": [
        5106
    ],
    "nor-murik": [
        5106
    ],
    "natabui": [
        5108
    ],
    "northwestern mixe": [
        5115
    ],
    "nocten": [
        5116
    ],
    "noctenes": [
        5116
    ],
    "noctén": [
        5116
    ],
    "nahua": [
        5119
    ],
    "north central nochixtlán mixtec": [
        5124
    ],
    "nabi": [
        5125,
        5321
    ],
    "nambieb": [
        5125
    ],
    "ndagam": [
        5138
    ],
    "nyoking": [
        5138
    ],
    "nyong": [
        5138,
        8865
    ],
    "nyongnepa": [
        5138
    ],
    "naattu": [
        5145
    ],
    "ninde": [
        5182
    ],
    "nide": [
        5182
    ],
    "nyamwanga": [
        5186
    ],
    "namwanga": [
        5186
    ],
    "northwest oaxaca mixtec": [
        5205
    ],
    "ndaꞌi": [
        5206
    ],
    "nda’i": [
        5206
    ],
    "ngwalkwe": [
        5210
    ],
    "nä": [
        5227
    ],
    "nuxaá": [
        5229
    ],
    "ningotsie": [
        5264
    ],
    "nɔri": [
        5266
    ],
    "nigeria mambila": [
        5266
    ],
    "nor tagbo": [
        5266
    ],
    "nauruan": [
        5282
    ],
    "naoero": [
        5282
    ],
    "namla": [
        5283
    ],
    "nambikuára, southern": [
        5284
    ],
    "nambikuára": [
        5284
    ],
    "nambicuara": [
        5284
    ],
    "nambikwara": [
        5284
    ],
    "nambikwara do sul": [
        5284
    ],
    "nambiquara": [
        5284
    ],
    "narak": [
        5285
    ],
    "naka’ela": [
        5286
    ],
    "naka'ela": [
        5286
    ],
    "nabak": [
        5287
    ],
    "napa": [
        5287
    ],
    "naga pidgin": [
        5288
    ],
    "naga creole assamese": [
        5288
    ],
    "naga-assamese": [
        5288
    ],
    "nagamese": [
        5288
    ],
    "nagamiz": [
        5288
    ],
    "nalu": [
        5289
    ],
    "nalou": [
        5289
    ],
    "nakanai": [
        5290
    ],
    "nakonai": [
        5290
    ],
    "nalik": [
        5291
    ],
    "ngan’gityemerri": [
        5292
    ],
    "ngan'gityemerri": [
        5292
    ],
    "ngangi-tjemerri": [
        5292
    ],
    "naaba": [
        5298
    ],
    "naapa": [
        5298
    ],
    "naapaa": [
        5298
    ],
    "nawa sherpa": [
        5298
    ],
    "nawa": [
        5298,
        5456
    ],
    "napoletano-calabrese": [
        5299
    ],
    "napulitano": [
        5299
    ],
    "neapolitan": [
        5299
    ],
    "neapolitan-calabrese": [
        5299
    ],
    "nama (namibia)": [
        5300
    ],
    "namagowab": [
        5300
    ],
    "namakwa": [
        5300
    ],
    "namaqua": [
        5300
    ],
    "naraguta": [
        5301
    ],
    "naasioi": [
        5302
    ],
    "nasioi": [
        5302
    ],
    "ngwe": [
        5763,
        5303,
        6065,
        6066,
        6486
    ],
    "ngwoi": [
        5303
    ],
    "nkwoi": [
        5303
    ],
    "nawuri": [
        5304
    ],
    "nakwi": [
        5305
    ],
    "ngarrindjeri": [
        5306
    ],
    "narinjari": [
        5306
    ],
    "narinyerrie": [
        5306
    ],
    "narrinjeri": [
        5306
    ],
    "narrinyeri": [
        5306
    ],
    "narrin’yerree": [
        5306
    ],
    "ngarinyeri": [
        5306
    ],
    "nahuatl, coatepec": [
        5307
    ],
    "náhuatl de coatepec": [
        5307
    ],
    "norwegian bokmål": [
        5308,
        5309
    ],
    "norwegian": [
        5308,
        5309,
        5590,
        5617,
        5692,
        6546,
        6770,
        6771
    ],
    "nyemba": [
        5310
    ],
    "ngangela": [
        5310
    ],
    "nhemba": [
        5310
    ],
    "ndoe": [
        5311
    ],
    "naga, chang": [
        5312
    ],
    "ngbinda": [
        5313
    ],
    "ngminda": [
        5313
    ],
    "naga, konyak": [
        5314
    ],
    "nagarchal": [
        5315
    ],
    "nagar": [
        5315
    ],
    "nagarchi": [
        5315
    ],
    "ngamo": [
        5316
    ],
    "ngamawa": [
        5316
    ],
    "naga, mao": [
        5317
    ],
    "ngarinyman": [
        5318
    ],
    "ngaiman": [
        5318
    ],
    "ngarinman": [
        5318
    ],
    "ngrarmun": [
        5318
    ],
    "nake": [
        5319
    ],
    "ngbaka ma’bo": [
        5320
    ],
    "ngbaka": [
        5320,
        5421,
        5426
    ],
    "nbwaka": [
        5320
    ],
    "ngbaka limba": [
        5320
    ],
    "ngbaka ma'bo": [
        5320
    ],
    "nkukoli": [
        5322
    ],
    "nkokolle": [
        5322
    ],
    "nnam": [
        5323
    ],
    "nggem": [
        5324
    ],
    "numana": [
        5325
    ],
    "nimana": [
        5325
    ],
    "numana-nunku-gbantu-numbu": [
        5325
    ],
    "namibian sign language": [
        5326
    ],
    "namibian": [
        5326
    ],
    "naga, rongmei": [
        5329
    ],
    "nruanghmei": [
        5329
    ],
    "ngamambo": [
        5330
    ],
    "ngembo": [
        5330
    ],
    "ngbandi, southern": [
        5331
    ],
    "ngbandi": [
        5331,
        5422
    ],
    "ngbandi-ngiri": [
        5331
    ],
    "ngbandi-sud": [
        5331
    ],
    "ngwandi": [
        5331,
        5422
    ],
    "ningera": [
        5332
    ],
    "nagira": [
        5332
    ],
    "negira": [
        5332
    ],
    "ninggera": [
        5332
    ],
    "nabu": [
        5333
    ],
    "naho": [
        5333
    ],
    "nahu": [
        5333
    ],
    "ndo": [
        5333,
        5372
    ],
    "nicobarese, central": [
        5334,
        5335
    ],
    "nachering": [
        5337
    ],
    "nacchhering": [
        5337
    ],
    "nacering ra": [
        5337
    ],
    "nacering": [
        5337
    ],
    "nachering tûm": [
        5337
    ],
    "nachiring": [
        5337
    ],
    "nasring": [
        5337
    ],
    "nasru bhra": [
        5337
    ],
    "nasru": [
        5337
    ],
    "nagatiman": [
        5338
    ],
    "nagatman": [
        5338
    ],
    "notsi": [
        5339
    ],
    "nochi": [
        5339
    ],
    "nisga’a": [
        5340
    ],
    "nass": [
        5340
    ],
    "nisga'a": [
        5340
    ],
    "nisgha": [
        5340
    ],
    "nishga": [
        5340
    ],
    "nishka": [
        5340
    ],
    "nisk’a": [
        5340
    ],
    "nisqa’a": [
        5340
    ],
    "nahuatl, central huasteca": [
        5341
    ],
    "nāhuatlahtōlli": [
        5341,
        5466,
        5449,
        5464
    ],
    "náhuat de la huasteca central": [
        5341
    ],
    "náhuatl de la huasteca": [
        5341
    ],
    "nahuatl, northern puebla": [
        5343
    ],
    "north puebla aztec": [
        5343
    ],
    "north puebla sierra nahuatl": [
        5343
    ],
    "northern puebla nahuatl": [
        5343
    ],
    "náhuatl del norte de puebla": [
        5343
    ],
    "na-kara": [
        5344
    ],
    "nagara": [
        5344
    ],
    "nakara": [
        5344
    ],
    "nakarra": [
        5344
    ],
    "nakkara": [
        5344
    ],
    "nahuatl, michoacán": [
        5345
    ],
    "natural": [
        5345
    ],
    "nahuatl de michoacán": [
        5345
    ],
    "nambo": [
        5346
    ],
    "nambu": [
        5346
    ],
    "namna": [
        5346
    ],
    "nmbo": [
        5346
    ],
    "neherneh": [
        5347
    ],
    "nauna": [
        5347
    ],
    "naune": [
        5347
    ],
    "nagovis": [
        5348
    ],
    "nagovisi": [
        5348
    ],
    "nagovisinarai karetaake": [
        5348
    ],
    "nagovisinarai": [
        5348
    ],
    "northern katang": [
        5349,
        5350
    ],
    "nchane": [
        5351
    ],
    "ncane": [
        5351
    ],
    "nchaney": [
        5351
    ],
    "nchanti": [
        5351
    ],
    "ntshanti": [
        5351
    ],
    "nicaraguan sign language": [
        5352
    ],
    "nicaraguan": [
        5352
    ],
    "nicaragüense": [
        5352
    ],
    "nsl": [
        5352,
        5689
    ],
    "naga, chothe": [
        5353,
        5354
    ],
    "nchimburu": [
        5355
    ],
    "nchumburu": [
        5355
    ],
    "nchummuru": [
        5355
    ],
    "nahuatl, central puebla": [
        5356
    ],
    "náhuatl del suroeste de puebla": [
        5356
    ],
    "natchez": [
        5357
    ],
    "ndebele": [
        5358,
        5661,
        5662
    ],
    "ndebele of zimbabwe": [
        5358
    ],
    "north ndebele": [
        5358
    ],
    "northern ndebele": [
        5358
    ],
    "ndasa": [
        5359
    ],
    "ndash": [
        5359
    ],
    "ndasha": [
        5359
    ],
    "ndassa": [
        5359
    ],
    "nsei": [
        5360
    ],
    "nsey": [
        5360
    ],
    "ndop-bamessing": [
        5360
    ],
    "ndau": [
        5361,
        7967
    ],
    "ndzawu": [
        5361
    ],
    "nde-nsele-nta": [
        5362
    ],
    "nadruvian": [
        5363
    ],
    "ndengereko": [
        5364
    ],
    "ndengeleko": [
        5364
    ],
    "ndali": [
        5365
    ],
    "ndari": [
        5365
    ],
    "ndi": [
        5366
    ],
    "ndamba": [
        5367
    ],
    "ndaka": [
        5368
    ],
    "ndaaka": [
        5368
    ],
    "ndolo": [
        5369
    ],
    "ndoolo": [
        5369
    ],
    "ndam": [
        5370
    ],
    "ndamm": [
        5370
    ],
    "ndu": [
        5372
    ],
    "ndombe": [
        5373
    ],
    "ndoola": [
        5374
    ],
    "ndola": [
        5374
    ],
    "ndoro": [
        5374
    ],
    "njoyame": [
        5374
    ],
    "nundoro": [
        5374
    ],
    "neddersass’sch": [
        5375,
        5376
    ],
    "nedderdütsch": [
        5375
    ],
    "nedderdüütsch": [
        5375
    ],
    "neddersassisch": [
        5375
    ],
    "nedersaksisch": [
        5375
    ],
    "niederdeutsch": [
        5375
    ],
    "niedersächsisch": [
        5375
    ],
    "ndunga": [
        5377
    ],
    "ndut": [
        5379
    ],
    "ndoute": [
        5379
    ],
    "ndút": [
        5379
    ],
    "ndobo": [
        5380
    ],
    "ndoobo": [
        5380
    ],
    "nduga": [
        5381
    ],
    "ndauwa": [
        5381
    ],
    "ndugwa": [
        5381
    ],
    "ndogo": [
        5384
    ],
    "nepali (macrolanguage)": [
        5385,
        5386,
        5387,
        5388
    ],
    "nepalese": [
        5697,
        5385,
        5386
    ],
    "ngad’a, eastern": [
        5389
    ],
    "ngad’a": [
        5389,
        5774
    ],
    "ngada": [
        5774,
        5389
    ],
    "nedebang": [
        5391
    ],
    "nédebang": [
        5391
    ],
    "nde-gbite": [
        5392
    ],
    "nêlêmwa-nixumwak": [
        5393
    ],
    "nefamese": [
        5394
    ],
    "negidal": [
        5395
    ],
    "neghidal": [
        5395
    ],
    "negidaly": [
        5395
    ],
    "nyenkha": [
        5396
    ],
    "neo-hittite": [
        5397
    ],
    "neko": [
        5398
    ],
    "neku": [
        5399
    ],
    "nemi": [
        5400
    ],
    "nengone": [
        5401
    ],
    "nengonese": [
        5401
    ],
    "ná-meo": [
        5402
    ],
    "north central mixe": [
        5403
    ],
    "northeastern mixe": [
        5403
    ],
    "nerigo": [
        5404
    ],
    "nyamkat": [
        5405
    ],
    "nyamskad": [
        5405
    ],
    "nete": [
        5406
    ],
    "neo": [
        5407
    ],
    "nyaheun": [
        5408
    ],
    "nha heun": [
        5408
    ],
    "nha": [
        5408
    ],
    "nia hoen": [
        5408
    ],
    "nia": [
        5408
    ],
    "niahon": [
        5408
    ],
    "nyah heuny": [
        5408
    ],
    "nyahön": [
        5408
    ],
    "newar": [
        5409,
        5410,
        5411,
        5769
    ],
    "nepal bhasa": [
        5409,
        5410,
        5411
    ],
    "newa bhaye": [
        5409,
        5410,
        5411
    ],
    "newa": [
        5409,
        5410,
        5411
    ],
    "newaah bhaae": [
        5409,
        5410,
        5411
    ],
    "newaah": [
        5409,
        5410,
        5411
    ],
    "newaah bhaaye": [
        5409,
        5410,
        5411
    ],
    "newah": [
        5409,
        5410,
        5411
    ],
    "newal bhaye": [
        5409,
        5410,
        5411
    ],
    "newal": [
        5409,
        5410,
        5411
    ],
    "neme": [
        5412,
        6836
    ],
    "neyo": [
        5413,
        8203
    ],
    "nez perce": [
        5414
    ],
    "nez": [
        5414
    ],
    "niimi’ipuutímt": [
        5414
    ],
    "niimíipu": [
        5414
    ],
    "nuumiipuutimt": [
        5414
    ],
    "ndao": [
        5415
    ],
    "ndaonese": [
        5415
    ],
    "ndaundau": [
        5415
    ],
    "naaude": [
        5417
    ],
    "nifilole": [
        5417
    ],
    "nivo": [
        5417
    ],
    "nafaanra": [
        5418
    ],
    "nafaara": [
        5418
    ],
    "nafana": [
        5418
    ],
    "nfumte": [
        5419
    ],
    "ndonga": [
        5420
    ],
    "ngbaka gbaya": [
        5421
    ],
    "ngbaka minagende": [
        5421
    ],
    "ngbandi, northern": [
        5422
    ],
    "ngbandi du nord": [
        5422
    ],
    "nord": [
        5422,
        6064,
        6734,
        6735,
        7767
    ],
    "northern ngbandi": [
        5422
    ],
    "ngombe": [
        5423,
        5571
    ],
    "ngombe (democratic republic of congo)": [
        5423
    ],
    "ngando": [
        5424,
        5772
    ],
    "ngando (central african republic)": [
        5424
    ],
    "ngando-kota": [
        5424
    ],
    "ngemba": [
        5425
    ],
    "nguemba": [
        5425,
        5599
    ],
    "ngbaka manza": [
        5426
    ],
    "nǁng": [
        5427
    ],
    "nghuki": [
        5427
    ],
    "ng’uki": [
        5427
    ],
    "nǀhuuki": [
        5427
    ],
    "nǀu": [
        5427
    ],
    "nǀuu": [
        5427
    ],
    "nǀuuki": [
        5427
    ],
    "ngizim": [
        5428
    ],
    "ngezzim": [
        5428
    ],
    "ngizmawa": [
        5428
    ],
    "ngie": [
        5429
    ],
    "ngi": [
        5429
    ],
    "nalabon": [
        5430
    ],
    "ngalabon": [
        5430
    ],
    "ngalkbon": [
        5430
    ],
    "ngalkbun": [
        5430
    ],
    "ngulu": [
        5434,
        5431,
        5553
    ],
    "ngatik men’s creole": [
        5432
    ],
    "ngatik": [
        5432
    ],
    "ngatik men's creole": [
        5432
    ],
    "ngatikese": [
        5432
    ],
    "ngatikese men’s language": [
        5432
    ],
    "ngwo": [
        5433
    ],
    "ngwaw": [
        5433
    ],
    "ngoreme": [
        5435
    ],
    "ngruimi": [
        5435
    ],
    "ngurimi": [
        5435
    ],
    "nguruimi": [
        5435
    ],
    "nagu": [
        5436
    ],
    "nanggu": [
        5436
    ],
    "nggweshe": [
        5437
    ],
    "ngoshe sama": [
        5437
    ],
    "ngoshe": [
        5437
    ],
    "ngoshe-ndhang": [
        5437
    ],
    "ngoshi": [
        5437
    ],
    "ngossi": [
        5437
    ],
    "ngweshe-ndaghang": [
        5437
    ],
    "ngweshe-ndhang": [
        5437
    ],
    "ngae": [
        5438
    ],
    "ngeh": [
        5438
    ],
    "ngeq": [
        5438
    ],
    "nge’": [
        5438
    ],
    "ngkriang": [
        5438
    ],
    "nhae": [
        5438
    ],
    "nkriang": [
        5438
    ],
    "nahuatl, guerrero": [
        5439
    ],
    "náhuatl de guerrero": [
        5439
    ],
    "nagumi": [
        5440
    ],
    "ngwaba": [
        5441
    ],
    "nggwahyi": [
        5442
    ],
    "ngwaxi": [
        5442
    ],
    "ngwohi": [
        5442
    ],
    "ngayaba": [
        5443
    ],
    "njanti": [
        5443
    ],
    "nyabea": [
        5443
    ],
    "ngungwel": [
        5444
    ],
    "ngangoulou": [
        5444
    ],
    "ngangulu": [
        5444
    ],
    "ngungulu": [
        5444
    ],
    "northeastern teke": [
        5444
    ],
    "nhanda": [
        5445
    ],
    "nanda": [
        5445
    ],
    "nanta": [
        5445
    ],
    "nhanta": [
        5445
    ],
    "nubda": [
        5445
    ],
    "nunta": [
        5445
    ],
    "nahuatl, tabasco": [
        5447
    ],
    "nandeva": [
        5448,
        7667
    ],
    "nhandeva": [
        5448
    ],
    "nahuatl, eastern huasteca": [
        5449
    ],
    "náhuatl de hidalgo": [
        5449
    ],
    "náhuatl de la huasteca oriental": [
        5449
    ],
    "nhuwala": [
        5450
    ],
    "nahuatl, tetelcingo": [
        5451
    ],
    "nahari": [
        5452
    ],
    "nahali": [
        5558,
        5452
    ],
    "nahuatl, zacatlán-ahuacatlán-tepetzintla": [
        5453
    ],
    "nahuatl, isthmus-cosoleacaque": [
        5454
    ],
    "náhuatl del istmo-cosoleacaque": [
        5454
    ],
    "nahuatl, morelos": [
        5455
    ],
    "náhuatl de cuentepec": [
        5455
    ],
    "nahuatl, central": [
        5456
    ],
    "náhuatl del centro": [
        5456
    ],
    "nahuatl, isthmus-pajapan": [
        5458
    ],
    "nahuatl del istmo bajo": [
        5458
    ],
    "náhuat de pajapan": [
        5458
    ],
    "nahuatl, huaxcaleca": [
        5459
    ],
    "náhuatl de chichiquila": [
        5459
    ],
    "naro": [
        5460
    ],
    "nharo": [
        5460
    ],
    "nharon": [
        5460
    ],
    "nhauru": [
        5460
    ],
    "nhaurun": [
        5460
    ],
    "nahuatl, ometepec": [
        5461
    ],
    "noone": [
        5462
    ],
    "nooni": [
        5462
    ],
    "noni": [
        5462
    ],
    "nahuatl, temascaltepec": [
        5463
    ],
    "nahuatl, western huasteca": [
        5464
    ],
    "náhuatl de tamazunchale": [
        5464
    ],
    "náhuatl de la huasteca occidental": [
        5464
    ],
    "nahuatl, isthmus-mecayapan": [
        5465
    ],
    "nahuatl del istmo": [
        5465
    ],
    "náhuat de mecayapan": [
        5465
    ],
    "náhuatl sur de veracruz": [
        5465
    ],
    "nahuatl, northern oaxaca": [
        5466
    ],
    "nahuatl de oaxaca": [
        5466
    ],
    "northern oaxaca nahuatl": [
        5466
    ],
    "náhuatl del norte de oaxaca": [
        5466
    ],
    "nahuatl, santa maría la alta": [
        5467
    ],
    "náhuatl de santa maría la alta": [
        5467
    ],
    "nias": [
        5468
    ],
    "niha": [
        5468
    ],
    "nakame": [
        5469
    ],
    "nakama": [
        5469
    ],
    "ngandi": [
        5470
    ],
    "niellim": [
        5471
    ],
    "nielim": [
        5471
    ],
    "nyilem": [
        5471
    ],
    "nek": [
        5472
    ],
    "ngalakgan": [
        5473
    ],
    "ngalakan": [
        5473
    ],
    "ngalangan": [
        5473
    ],
    "nyiha, tanzania": [
        5474
    ],
    "nyiha": [
        5474,
        5804
    ],
    "nyiha (tanzania)": [
        5474
    ],
    "nyika": [
        5530,
        5532,
        5474,
        5792
    ],
    "nyixa": [
        5474
    ],
    "nii": [
        5475
    ],
    "ngaju": [
        5476
    ],
    "ngadju": [
        5476,
        5506
    ],
    "ngaja": [
        5476
    ],
    "ngaju dayak": [
        5476
    ],
    "nicobarese, southern": [
        5477
    ],
    "nila": [
        5478
    ],
    "nilamba": [
        5479
    ],
    "nilyamba": [
        5479
    ],
    "niramba": [
        5479
    ],
    "nyilamba": [
        5479
    ],
    "nyiramba": [
        5479
    ],
    "ninzo": [
        5480
    ],
    "ninzam": [
        5480
    ],
    "nunzo": [
        5480
    ],
    "nganasan": [
        5481
    ],
    "nandi": [
        5482,
        5592
    ],
    "naandi": [
        5482
    ],
    "nimboran": [
        5483
    ],
    "nambrong": [
        5483
    ],
    "nmblong nmbuo": [
        5483
    ],
    "nmblong": [
        5483
    ],
    "nmbuo": [
        5483
    ],
    "nimi": [
        5484
    ],
    "niuean": [
        5486
    ],
    "niuē": [
        5486
    ],
    "nivkh": [
        5487,
        5488
    ],
    "nivkhi": [
        5487,
        5488
    ],
    "nivxgu": [
        5487,
        5488
    ],
    "nimo": [
        5489
    ],
    "nimo-wasawai": [
        5489
    ],
    "nyoro": [
        5801,
        5490
    ],
    "ngiti": [
        5491
    ],
    "ndruna": [
        5491
    ],
    "ngeti": [
        5491
    ],
    "ningil": [
        5492
    ],
    "nzanyi": [
        5493
    ],
    "njai": [
        5493
    ],
    "njanyi": [
        5493
    ],
    "njegn": [
        5493
    ],
    "njei": [
        5493
    ],
    "njeing": [
        5493
    ],
    "njeng": [
        5493
    ],
    "njeny": [
        5493
    ],
    "nzangi": [
        5493
    ],
    "naga, nocte": [
        5494
    ],
    "nocte": [
        5494
    ],
    "namsangia": [
        5494
    ],
    "nocte naga": [
        5494
    ],
    "nokte": [
        5494
    ],
    "ndonde hamba": [
        5495
    ],
    "ndonde": [
        5495
    ],
    "ndomde": [
        5495
    ],
    "naga, lotha": [
        5496
    ],
    "ngarnga": [
        5497
    ],
    "njen": [
        5498
    ],
    "nen": [
        5656,
        5498,
        7814
    ],
    "nyen": [
        5498
    ],
    "nzin": [
        5498
    ],
    "njalgulgule": [
        5499
    ],
    "ngulgule": [
        5499
    ],
    "njangulgule": [
        5499
    ],
    "nyolge": [
        5499
    ],
    "nyoolne": [
        5499
    ],
    "naga, angami": [
        5500
    ],
    "ngami": [
        5500
    ],
    "naga, liangmai": [
        5501
    ],
    "naga, ao": [
        5502
    ],
    "nowgong": [
        5502
    ],
    "njerep": [
        5503
    ],
    "njerup": [
        5503
    ],
    "nisa": [
        5504
    ],
    "ndyuka-trio pidgin": [
        5505
    ],
    "ndyuka-trio": [
        5505
    ],
    "ngadjunmaya": [
        5506
    ],
    "ngadjumaja": [
        5506
    ],
    "ngadjumaya": [
        5506
    ],
    "ngadjunmaia": [
        5506
    ],
    "ngajumaya": [
        5506
    ],
    "ngatju": [
        5506
    ],
    "ngatjumay": [
        5506
    ],
    "njyem": [
        5508
    ],
    "ndjem": [
        5508
    ],
    "ndjeme": [
        5508
    ],
    "ndzem": [
        5508
    ],
    "ngyeme": [
        5508
    ],
    "njem": [
        5508
    ],
    "njeme": [
        5508
    ],
    "njém": [
        5508
    ],
    "nyem": [
        5508
    ],
    "nyishi": [
        5509,
        5510
    ],
    "nil": [
        5509,
        5510,
        6068,
        6069,
        6070,
        7454
    ],
    "nishi": [
        5509,
        5510
    ],
    "nissi": [
        5509,
        5510
    ],
    "nyising": [
        5509,
        5510
    ],
    "nkoya": [
        5511
    ],
    "naga, khoibu": [
        5512
    ],
    "nkongho": [
        5513
    ],
    "ndughore": [
        5515
    ],
    "nduke": [
        5515
    ],
    "naga, inpui": [
        5516
    ],
    "nekgini": [
        5517
    ],
    "nakgini": [
        5517
    ],
    "nekeni": [
        5517
    ],
    "naga, khezha": [
        5518
    ],
    "naga, thangal": [
        5519,
        5520
    ],
    "ngari": [
        5519,
        5520,
        6644
    ],
    "nakai": [
        5521
    ],
    "nagai": [
        5521
    ],
    "na’ai": [
        5521
    ],
    "na’i": [
        5521
    ],
    "nokuku": [
        5522
    ],
    "nogugu": [
        5522
    ],
    "namat": [
        5523
    ],
    "nkangala": [
        5524
    ],
    "ngangala": [
        5524
    ],
    "nkonya": [
        5525
    ],
    "nkunya": [
        5525
    ],
    "niuatoputapu": [
        5526
    ],
    "nkami": [
        5527
    ],
    "nukuoro": [
        5528
    ],
    "nuguor": [
        5528
    ],
    "nukoro": [
        5528
    ],
    "north asmat": [
        5529
    ],
    "nyika, tanzania": [
        5530
    ],
    "nyika (tanzania)": [
        5530
    ],
    "nyika (malawi and zambia)": [
        5532
    ],
    "nkuchu": [
        5533
    ],
    "nkucu": [
        5533
    ],
    "nkutshu": [
        5533
    ],
    "nkoroo": [
        5534
    ],
    "nkoro": [
        5534
    ],
    "nkari": [
        5535
    ],
    "nederlands": [
        5536,
        5537,
        5538,
        5539,
        5541,
        5542,
        5543,
        5540
    ],
    "ngombale": [
        5544
    ],
    "nalca": [
        5545
    ],
    "nalja": [
        5545
    ],
    "naltje": [
        5545
    ],
    "naltya": [
        5545
    ],
    "nyala": [
        5546
    ],
    "nggela": [
        5547
    ],
    "nyali": [
        5549,
        8061
    ],
    "north nyali": [
        5549
    ],
    "nyali-kilo": [
        5549
    ],
    "nyari": [
        5549
    ],
    "ninia": [
        5550
    ],
    "ninia yali": [
        5550
    ],
    "north ngalik": [
        5550,
        8719
    ],
    "ngalik": [
        8364,
        8831,
        5550,
        8719
    ],
    "nihali": [
        5551
    ],
    "nihal": [
        5551
    ],
    "ngul": [
        5553
    ],
    "ngoli": [
        5553
    ],
    "nguli": [
        5553
    ],
    "ngwii": [
        5553
    ],
    "naga, lao": [
        5554
    ],
    "nchumbulu": [
        5555
    ],
    "nahuatl, orizaba": [
        5556
    ],
    "nawatl de orizaba": [
        5556
    ],
    "nawatl": [
        5556
    ],
    "náhuatl de orizaba": [
        5556
    ],
    "náhuatl de la sierra de zongolica": [
        5556
    ],
    "nāwatl": [
        5556
    ],
    "nahal": [
        5558
    ],
    "nahale": [
        5558
    ],
    "nahalia": [
        5558
    ],
    "nyamal": [
        5559
    ],
    "namel": [
        5559
    ],
    "njamal": [
        5559
    ],
    "njamarl": [
        5559
    ],
    "nyamel": [
        5559
    ],
    "nalögo": [
        5560
    ],
    "nalrgo": [
        5560
    ],
    "nea": [
        5560
    ],
    "naga, maram": [
        5561
    ],
    "ngam": [
        5563
    ],
    "ngahm": [
        5563
    ],
    "ngama": [
        5563
    ],
    "ngamh": [
        5563
    ],
    "ngàm̄": [
        5563
    ],
    "ndumu": [
        5564
    ],
    "ndumbo": [
        5564
    ],
    "ndumbu": [
        5564
    ],
    "nduumo": [
        5564
    ],
    "naga, mzieme": [
        5565
    ],
    "northern zeme": [
        5565
    ],
    "naga, tangkhul": [
        5566,
        5722
    ],
    "ngoumba": [
        5567,
        5568
    ],
    "ngumba": [
        5567,
        5568
    ],
    "naga, monsang": [
        5569
    ],
    "nyambolo": [
        5570
    ],
    "ngombe (central african republic)": [
        5571
    ],
    "ngombe-kaka": [
        5571
    ],
    "namakura": [
        5572
    ],
    "namakir": [
        5572
    ],
    "ndemli": [
        5573
    ],
    "ndemba": [
        5573
    ],
    "nyeshangte": [
        5574,
        5575
    ],
    "nyangmi": [
        5574,
        5575
    ],
    "nyangmi ke": [
        5574,
        5575
    ],
    "nyeshang": [
        5574,
        5575
    ],
    "nyeshangte ke": [
        5574,
        5575
    ],
    "nyisang": [
        5574,
        5575
    ],
    "nyishang": [
        5574,
        5575
    ],
    "nyishangba": [
        5574,
        5575
    ],
    "n/amani": [
        5576
    ],
    "ngǀamani": [
        5576
    ],
    "naga, moyon": [
        5577,
        5578
    ],
    "nimanbur": [
        5579
    ],
    "nimanburru": [
        5579
    ],
    "nambya": [
        5580
    ],
    "nambzya": [
        5580
    ],
    "nanzva": [
        5580
    ],
    "nimbari": [
        5581
    ],
    "niam-niam": [
        5581
    ],
    "niamniam": [
        5581
    ],
    "nimbari-kebi": [
        5581
    ],
    "nyam-nyam du mayo-kebi": [
        5581
    ],
    "nyam-nyam": [
        5581
    ],
    "nyamnyam": [
        5581
    ],
    "namonuito": [
        5583
    ],
    "namon weite": [
        5583
    ],
    "namon": [
        5583
    ],
    "northeast maidu": [
        5584
    ],
    "ngamini": [
        5585
    ],
    "nimoa": [
        5586
    ],
    "nama (papua new guinea)": [
        5587
    ],
    "namuyi": [
        5588
    ],
    "naimuci": [
        5588
    ],
    "naimuzi": [
        5588
    ],
    "namuzi": [
        5588
    ],
    "nawdm": [
        5589
    ],
    "naoudem": [
        5589
    ],
    "naudm": [
        5589
    ],
    "nawdam": [
        5589
    ],
    "norwegian nynorsk": [
        5590
    ],
    "nynorsk": [
        5590
    ],
    "norsk nynorsk": [
        5590
    ],
    "norsk": [
        5590,
        5617,
        5692
    ],
    "nyangumarta": [
        5591
    ],
    "njangumarda": [
        5591
    ],
    "njangumarta": [
        5591
    ],
    "nyangumarda": [
        5591
    ],
    "nyangumata": [
        5591
    ],
    "nande": [
        5592
    ],
    "ndande": [
        5592
    ],
    "ndandi": [
        5592
    ],
    "northern nande": [
        5592
    ],
    "nancere": [
        5593
    ],
    "nanchere": [
        5593
    ],
    "nangcere": [
        5593
    ],
    "nangjere": [
        5593
    ],
    "nangtchere": [
        5593
    ],
    "nanjeri": [
        5593
    ],
    "nantcere": [
        5593
    ],
    "ngandjera": [
        5595
    ],
    "ngandyera": [
        5595
    ],
    "ngaing": [
        5596
    ],
    "naga, maring": [
        5597,
        5598
    ],
    "ngiemboon": [
        5599
    ],
    "ngiembɔɔn": [
        5599
    ],
    "ngyemboon": [
        5599
    ],
    "nuaulu, north": [
        5600
    ],
    "nuaulu": [
        5600,
        5777
    ],
    "north nuaulu": [
        5600
    ],
    "nyangatom": [
        5601
    ],
    "nankina": [
        5602
    ],
    "naga, northern rengma": [
        5603
    ],
    "northern rengma": [
        5603
    ],
    "northern rengma naga": [
        5603
    ],
    "ntenyi": [
        5603
    ],
    "ntenyi naga": [
        5603
    ],
    "nthenyi": [
        5603
    ],
    "namia": [
        5604
    ],
    "namie": [
        5604
    ],
    "nemia": [
        5604
    ],
    "ngete": [
        5605
    ],
    "ngueté": [
        5605
    ],
    "nge’dé": [
        5605
    ],
    "nguetté": [
        5605
    ],
    "naga, wancho": [
        5606,
        5607,
        5608
    ],
    "naga wancho": [
        5606,
        5607,
        5608
    ],
    "ngindo": [
        5609
    ],
    "njindo": [
        5609
    ],
    "njinjo": [
        5609
    ],
    "narungga": [
        5610
    ],
    "nanunga": [
        5610
    ],
    "naranga": [
        5610
    ],
    "narangga": [
        5610
    ],
    "narranga": [
        5610
    ],
    "narranggu": [
        5610
    ],
    "narrangu": [
        5610
    ],
    "nanticoke": [
        5611
    ],
    "nchumunu": [
        5612
    ],
    "nugunu": [
        5613,
        8738
    ],
    "njuguna": [
        5613
    ],
    "nokunna": [
        5613
    ],
    "noocoona": [
        5613
    ],
    "nookoona": [
        5613
    ],
    "nuguna": [
        5613
    ],
    "nugunu (australia)": [
        5613
    ],
    "nukana": [
        5613
    ],
    "nukuna": [
        5613
    ],
    "nukunnu": [
        5613
    ],
    "nukunu": [
        5613
    ],
    "nuni, southern": [
        5614
    ],
    "nuni": [
        5614,
        5747
    ],
    "nʋnɩ": [
        5614
    ],
    "nibulu": [
        5614,
        5747
    ],
    "nouni": [
        5614,
        5747
    ],
    "nounouma": [
        5614,
        5747
    ],
    "nuna": [
        5614,
        5747
    ],
    "nune": [
        5614,
        5747
    ],
    "nunuma": [
        5614,
        5747
    ],
    "nuruma": [
        5614,
        5747
    ],
    "nyangga": [
        5615,
        8222
    ],
    "njangga": [
        5615,
        8222
    ],
    "njanggala": [
        5615
    ],
    "nda’nda’": [
        5616
    ],
    "nda'nda'": [
        5616
    ],
    "noanama": [
        5618
    ],
    "noenama": [
        5618
    ],
    "nonama": [
        5618
    ],
    "nuk": [
        5619
    ],
    "northern thai": [
        5620,
        5621
    ],
    "nimadi": [
        5622
    ],
    "nemadi": [
        5622
    ],
    "nimari": [
        5622
    ],
    "nimiadi": [
        5622
    ],
    "nomane": [
        5623
    ],
    "nogai": [
        5624
    ],
    "nogaitsy": [
        5624
    ],
    "nogalar": [
        5624
    ],
    "nogay": [
        5624
    ],
    "noghai": [
        5624
    ],
    "noghay": [
        5624
    ],
    "noghaylar": [
        5624
    ],
    "nomu": [
        5625
    ],
    "noiri": [
        5626
    ],
    "nonuya": [
        5627
    ],
    "nononota": [
        5627
    ],
    "nooksack": [
        5628
    ],
    "nootsack": [
        5628
    ],
    "nomlaki": [
        5629
    ],
    "nocamán": [
        5630
    ],
    "norse": [
        5631
    ],
    "numanggang": [
        5632
    ],
    "numangan": [
        5632
    ],
    "numangang": [
        5632
    ],
    "ngongo": [
        5633
    ],
    "nisu, eastern": [
        5634
    ],
    "nisu": [
        5634,
        5684,
        5686,
        5705,
        8811
    ],
    "nisupho": [
        5634,
        5684,
        8811
    ],
    "nomatsigenga": [
        5635
    ],
    "nomatsiguenga": [
        5635
    ],
    "novial": [
        5637
    ],
    "nyambo": [
        5638
    ],
    "noy": [
        5639
    ],
    "nayi": [
        5640
    ],
    "nar phu": [
        5641
    ],
    "nar-phu": [
        5641
    ],
    "nupbikha": [
        5642
    ],
    "naga, ponyo-gongwang": [
        5643
    ],
    "naga, phom": [
        5644
    ],
    "nahuatl, southeastern puebla": [
        5645
    ],
    "náhuatl del sureste de puebla": [
        5645
    ],
    "náhuatl del valle de tehuacán": [
        5645
    ],
    "nawe mondropolon": [
        5646
    ],
    "nawe": [
        5646
    ],
    "naga, pochuri": [
        5647
    ],
    "nipsan": [
        5648
    ],
    "naga, puimei": [
        5649
    ],
    "noipä": [
        5650
    ],
    "noipx": [
        5650
    ],
    "napu": [
        5651
    ],
    "nago, southern": [
        5652
    ],
    "nago": [
        5652,
        8493,
        5653
    ],
    "nagot": [
        5652
    ],
    "nagots": [
        5652
    ],
    "ngendelengo": [
        5654
    ],
    "n’guendelengo": [
        5654
    ],
    "ndom": [
        5655
    ],
    "nen ym": [
        5656
    ],
    "nen zi": [
        5656
    ],
    "n’ko": [
        5657
    ],
    "n'ko": [
        5657
    ],
    "naga, chen-kayu": [
        5658
    ],
    "nteng": [
        5659
    ],
    "naga, akyaung ari": [
        5660
    ],
    "ngachan": [
        5660
    ],
    "ndzundza": [
        5661,
        5662
    ],
    "nrebele": [
        5661,
        5662
    ],
    "ngom": [
        5663
    ],
    "ngomo": [
        5663
    ],
    "nara": [
        5664,
        5680
    ],
    "nara bana": [
        5664
    ],
    "nera": [
        5664
    ],
    "noric": [
        5665
    ],
    "naga, southern rengma": [
        5666
    ],
    "nzong": [
        5666
    ],
    "nzonyu": [
        5666
    ],
    "norman": [
        5667
    ],
    "norman french": [
        5667
    ],
    "normand": [
        5667
    ],
    "normaund": [
        5667
    ],
    "narango": [
        5668
    ],
    "naga, chokri": [
        5669
    ],
    "ngarla": [
        5670
    ],
    "ngalana": [
        5670
    ],
    "ngerla": [
        5670
    ],
    "ngirla": [
        5670
    ],
    "ngurla": [
        5670
    ],
    "ngarluma": [
        5671
    ],
    "ngallooma": [
        5671
    ],
    "ngaluma": [
        5671
    ],
    "narom": [
        5672
    ],
    "narum": [
        5672
    ],
    "norn": [
        5673,
        5674
    ],
    "north picene": [
        5675
    ],
    "norra": [
        5676
    ],
    "noza": [
        5676
    ],
    "nurra": [
        5676
    ],
    "northern kalapuya": [
        5677
    ],
    "narua": [
        5678
    ],
    "naxi": [
        5781,
        5782,
        5783,
        5678
    ],
    "naru": [
        5678
    ],
    "nazu": [
        5678
    ],
    "ngurmbur": [
        5679
    ],
    "ngomburr": [
        5679
    ],
    "ngormbur": [
        5679
    ],
    "ngumbur": [
        5679
    ],
    "nala": [
        5680
    ],
    "naga, sangtam": [
        5681
    ],
    "nossob": [
        5682
    ],
    "nshi": [
        5683
    ],
    "nisu, southern": [
        5684
    ],
    "nsenga": [
        5685
    ],
    "nisu, northwestern": [
        5686
    ],
    "northwestern nisu": [
        5686
    ],
    "ngasa": [
        5687
    ],
    "ngoshie": [
        5688
    ],
    "ngishe": [
        5688
    ],
    "nigerian sign language": [
        5689
    ],
    "naskapi": [
        5690,
        5691
    ],
    "naaskaapii iyuw iyimuuun": [
        5690,
        5691
    ],
    "naaskaapii": [
        5690,
        5691
    ],
    "naskapi innu": [
        5690,
        5691
    ],
    "norwegian sign language": [
        5692
    ],
    "nts": [
        5692
    ],
    "norsk tegnspråk": [
        5692
    ],
    "naga, sumi": [
        5693
    ],
    "nehan": [
        5694
    ],
    "nihan": [
        5694
    ],
    "nissan": [
        5694
    ],
    "northern sotho": [
        5695,
        5696
    ],
    "nepalese sign language": [
        5697
    ],
    "nepali sign language": [
        5697
    ],
    "npsl": [
        5697
    ],
    "northern sierra miwok": [
        5698
    ],
    "nova scotia sign language": [
        5699
    ],
    "nova scotian sign language": [
        5699
    ],
    "nali": [
        5700
    ],
    "naga, tangshang": [
        5701,
        5703,
        5702
    ],
    "naga, tangsa": [
        5702,
        5701,
        5703
    ],
    "naga, tangshang - moshang hawa": [
        5703
    ],
    "nahuatl, sierra negra": [
        5704
    ],
    "negra": [
        5704
    ],
    "náhuatl de la sierra negra": [
        5704
    ],
    "nisu, southwestern": [
        5705
    ],
    "navut": [
        5706
    ],
    "nsongo": [
        5707
    ],
    "nasal": [
        5708
    ],
    "nisenan": [
        5709
    ],
    "neeshenam": [
        5709
    ],
    "nishinam": [
        5709
    ],
    "nonukan": [
        5710
    ],
    "northern tidung": [
        5710
    ],
    "nathembo": [
        5711
    ],
    "ngantangarra": [
        5712
    ],
    "ngandangara": [
        5712
    ],
    "natioro": [
        5713
    ],
    "natjoro": [
        5713
    ],
    "natyoro": [
        5713
    ],
    "ngaanyatjarra": [
        5714
    ],
    "ngaanjatjarra": [
        5714
    ],
    "ngaanyatjara": [
        5714
    ],
    "nateni": [
        5716
    ],
    "naàteǹni": [
        5716
    ],
    "naténi": [
        5716
    ],
    "ntomba": [
        5717
    ],
    "ntomba-bolia": [
        5717
    ],
    "ntumba": [
        5717
    ],
    "northern tepehuan": [
        5718
    ],
    "ntribou": [
        5719
    ],
    "ntribu": [
        5719
    ],
    "ntrubo": [
        5719
    ],
    "natügu": [
        5720
    ],
    "nambakaengö": [
        5720
    ],
    "natqgu": [
        5720
    ],
    "northern santa cruz": [
        5720
    ],
    "nottoway": [
        5721
    ],
    "natanzi": [
        5724
    ],
    "nua": [
        5725
    ],
    "nyua": [
        5725
    ],
    "nyuaanga": [
        5725
    ],
    "nukuini": [
        5726
    ],
    "nucuini": [
        5726,
        6500
    ],
    "nukini": [
        5726
    ],
    "nuquini": [
        5726
    ],
    "ngundu": [
        5728
    ],
    "nusu": [
        5729
    ],
    "nang tsu": [
        5729
    ],
    "nang": [
        5729
    ],
    "no tso": [
        5729
    ],
    "no tsu": [
        5729
    ],
    "nungali": [
        5730
    ],
    "ndunda": [
        5731,
        8082
    ],
    "nyole": [
        5733,
        5790
    ],
    "nyule": [
        5733
    ],
    "nyuli": [
        5733
    ],
    "nuu-chah-nulth": [
        5734
    ],
    "nootka": [
        5734
    ],
    "nootkans": [
        5734
    ],
    "nutka": [
        5734
    ],
    "nuuchahnulth": [
        5734
    ],
    "nuučaan’ul": [
        5734
    ],
    "nusa laut": [
        5735
    ],
    "nusalaut": [
        5735
    ],
    "niuafo’ou": [
        5736
    ],
    "niuafo'ou": [
        5736
    ],
    "naw": [
        5737
    ],
    "nawpha": [
        5737
    ],
    "nguôn": [
        5738
    ],
    "ngoaun": [
        5738
    ],
    "ngouan": [
        5738
    ],
    "nguan": [
        5738
    ],
    "nguane": [
        5738
    ],
    "nupe-nupe-tako": [
        5739,
        5740
    ],
    "nupe": [
        5739,
        5740
    ],
    "nufawa": [
        5739,
        5740
    ],
    "nupeci": [
        5739,
        5740
    ],
    "nupenchi": [
        5739,
        5740
    ],
    "nukumanu": [
        5741
    ],
    "nukeria": [
        5742
    ],
    "nahoa": [
        5742
    ],
    "nuguria": [
        5742
    ],
    "nukuria": [
        5742
    ],
    "nuer": [
        5743,
        5744
    ],
    "nath": [
        5743,
        5744
    ],
    "naadh": [
        5743
    ],
    "naath": [
        5743
    ],
    "nung (viet nam)": [
        5745
    ],
    "nùng": [
        5745
    ],
    "ngbundu": [
        5746
    ],
    "nuni, northern": [
        5747
    ],
    "northern nuni": [
        5747
    ],
    "nguluwan": [
        5748
    ],
    "nuku": [
        5749
    ],
    "nunggubuyu": [
        5750
    ],
    "nunggubuju": [
        5750
    ],
    "nahuatl, tlamacazapa": [
        5751
    ],
    "navajo": [
        5752
    ],
    "naabeehó bizaad": [
        5752
    ],
    "naabeehó": [
        5752
    ],
    "navaho": [
        5752
    ],
    "nasarian": [
        5753
    ],
    "namiae": [
        5754
    ],
    "namiaiko": [
        5754
    ],
    "namiai": [
        5754
    ],
    "nyokon": [
        5755
    ],
    "ni nyo’o": [
        5755
    ],
    "nyo’o": [
        5755
    ],
    "nyo’on": [
        5755
    ],
    "nawathinehena": [
        5756
    ],
    "nyabwa": [
        5757
    ],
    "nyabobɔgʋ": [
        5757
    ],
    "niaboua": [
        5757
    ],
    "nyaboa": [
        5757
    ],
    "nyabobɔgo": [
        5757
    ],
    "nyabwa-nyédébwa": [
        5757
    ],
    "newari": [
        5758,
        5759,
        5760,
        5761,
        5762
    ],
    "nwe": [
        5763
    ],
    "nweh": [
        5763
    ],
    "ngayawung": [
        5764
    ],
    "ngaiawang": [
        5764
    ],
    "ngaiawung": [
        5764
    ],
    "ngayawang": [
        5764
    ],
    "nɨvhaar": [
        5765
    ],
    "naha": [
        5765
    ],
    "nvhal": [
        5765
    ],
    "nɨvhaal": [
        5765
    ],
    "nyamusa-molo": [
        5766
    ],
    "nauo": [
        5767
    ],
    "naua": [
        5767
    ],
    "nawo": [
        5767
    ],
    "nawu": [
        5767
    ],
    "nowo": [
        5767
    ],
    "nyaawa": [
        5767
    ],
    "nawaru": [
        5768
    ],
    "nottoway-meherrin": [
        5770
    ],
    "nauete": [
        5771
    ],
    "naueti": [
        5771
    ],
    "nauhete": [
        5771
    ],
    "nauote": [
        5771
    ],
    "nauoti": [
        5771
    ],
    "naóti": [
        5771
    ],
    "ngando (democratic republic of congo)": [
        5772
    ],
    "ngandu": [
        5772
    ],
    "nage": [
        5773
    ],
    "nage-keo": [
        5773,
        8703
    ],
    "nagé": [
        5773
    ],
    "nad’a": [
        5774
    ],
    "ngad'a": [
        5774
    ],
    "ngadha": [
        5774
    ],
    "nga’da": [
        5774
    ],
    "nindi": [
        5775
    ],
    "naga, kokak": [
        5776
    ],
    "nuaulu, south": [
        5777
    ],
    "numidian": [
        5778
    ],
    "ngawun": [
        5779
    ],
    "ndambomo": [
        5780
    ],
    "nahsi": [
        5781,
        5782,
        5783
    ],
    "nakhi": [
        5781,
        5782,
        5783
    ],
    "naqxi": [
        5781,
        5782,
        5783
    ],
    "nasi": [
        5781,
        5782,
        5783
    ],
    "ninggerum": [
        5784
    ],
    "ningerum": [
        5784
    ],
    "ninggeroem": [
        5784
    ],
    "ninggirum": [
        5784
    ],
    "ninggrum": [
        5784
    ],
    "niyium": [
        5784
    ],
    "nafri": [
        5785
    ],
    "nyanja": [
        5786,
        5787
    ],
    "nyanja-chewa": [
        5786,
        5787
    ],
    "nyangbo": [
        5788
    ],
    "nyanga-li": [
        5789
    ],
    "nyoole": [
        5790
    ],
    "nyore": [
        5790
    ],
    "nyengo": [
        5791
    ],
    "nhengo": [
        5791
    ],
    "nika": [
        5792
    ],
    "nyindu": [
        5793
    ],
    "nyikina": [
        5794
    ],
    "njigina": [
        5794
    ],
    "njikena": [
        5794
    ],
    "nyakina": [
        5794
    ],
    "nyigina": [
        5794
    ],
    "nyigini": [
        5794
    ],
    "nyiman": [
        5795
    ],
    "nyimang": [
        5795
    ],
    "nyuwing": [
        5795
    ],
    "nyanga": [
        5796
    ],
    "nyaneka": [
        5797
    ],
    "nhaneca": [
        5797
    ],
    "nhaneka": [
        5797
    ],
    "nyeu": [
        5798
    ],
    "nyamwezi": [
        5799
    ],
    "namwezi": [
        5799
    ],
    "nyamwesi": [
        5799
    ],
    "nyawezi": [
        5799
    ],
    "nyankore": [
        5800
    ],
    "nkole": [
        5800
    ],
    "nyankole": [
        5800
    ],
    "nyang’i": [
        5802
    ],
    "ngangea": [
        5802
    ],
    "ngapore": [
        5802
    ],
    "ngiangeya": [
        5802
    ],
    "niporen": [
        5802
    ],
    "nipori": [
        5802
    ],
    "nuangeya": [
        5802
    ],
    "nyang'i": [
        5802
    ],
    "nyangeya": [
        5802
    ],
    "nyangiya": [
        5802
    ],
    "nyang’ia": [
        5802
    ],
    "nyuangia": [
        5802
    ],
    "nayini": [
        5803
    ],
    "nyiha, malawi": [
        5804
    ],
    "nyiha (malawi)": [
        5804
    ],
    "nyungar": [
        5805,
        8619
    ],
    "njunga": [
        5805
    ],
    "njungar": [
        5805
    ],
    "noongar": [
        5805,
        8619
    ],
    "nyunga": [
        5805,
        6231
    ],
    "nyawaygi": [
        5806,
        8415
    ],
    "nawagi": [
        5806
    ],
    "nyungwe": [
        5807
    ],
    "nyongwe": [
        5807
    ],
    "nyulnyul": [
        5808
    ],
    "nyaw": [
        5809
    ],
    "nyoh": [
        5809
    ],
    "nganyaywana": [
        5810
    ],
    "nganjaywana": [
        5810
    ],
    "nyakyusa-ngonde": [
        5811
    ],
    "ngonde": [
        5811
    ],
    "nkhonde": [
        5811
    ],
    "nkonde": [
        5811
    ],
    "nyakusa": [
        5811
    ],
    "nyakyusa": [
        5811
    ],
    "nyekyosa": [
        5811
    ],
    "nyikyusa": [
        5811
    ],
    "noale": [
        5812
    ],
    "njebi": [
        5813
    ],
    "ndjabi": [
        5813
    ],
    "ndjevi": [
        5813
    ],
    "njabi": [
        5813
    ],
    "njevi": [
        5813
    ],
    "nzebi": [
        5813
    ],
    "nzèbi": [
        5813
    ],
    "nzɛbi": [
        5813
    ],
    "nzadi": [
        5814
    ],
    "nzema": [
        5815
    ],
    "nzima": [
        5815
    ],
    "nzakara": [
        5816
    ],
    "n’sakara": [
        5816
    ],
    "naga, zeme": [
        5817
    ],
    "new zealand sign language": [
        5818
    ],
    "nzsl": [
        5818
    ],
    "ndzindziu": [
        5819
    ],
    "njiunjiu": [
        5819
    ],
    "njyunjyu": [
        5819
    ],
    "nzakambay": [
        5820
    ],
    "njakambai": [
        5820
    ],
    "nzak mbai": [
        5820
    ],
    "nzak": [
        5820
    ],
    "nzak mbay": [
        5820
    ],
    "nzaka mbay": [
        5820
    ],
    "nzaka": [
        5820
    ],
    "nzakmbay": [
        5820
    ],
    "nanga dama dogon": [
        5821
    ],
    "nanga dogon": [
        5821
    ],
    "nishnaabemwin": [
        5859,
        5860,
        5994
    ],
    "nakawēmowin": [
        5861,
        5862,
        5868,
        5869
    ],
    "northern ojibwa": [
        5861,
        5862,
        5865,
        5866
    ],
    "northwestern ojibwa": [
        5861,
        5862
    ],
    "nahkawēwin": [
        5868,
        5869
    ],
    "nselxcin": [
        5870,
        5871
    ],
    "nsyilxcen": [
        5870,
        5871
    ],
    "nsyilxcən": [
        5870,
        5871
    ],
    "northeast ambae": [
        5905
    ],
    "northeast aoba": [
        5905
    ],
    "namnd": [
        5912
    ],
    "numurana": [
        5916
    ],
    "northern one": [
        5931
    ],
    "nebome": [
        5937
    ],
    "nevome": [
        5937
    ],
    "northwestern otomi": [
        5989
    ],
    "northeastern otomi": [
        5995
    ],
    "nzime": [
        6011
    ],
    "northern paiute": [
        6032
    ],
    "nasfurush": [
        6034
    ],
    "novos": [
        6038
    ],
    "nasa yuwe": [
        6043
    ],
    "nasa": [
        6043
    ],
    "nasayuwe": [
        6043
    ],
    "nyisam": [
        6052
    ],
    "nquivā": [
        6060
    ],
    "nhaang": [
        6062,
        6063
    ],
    "niang": [
        6062,
        6063
    ],
    "nà": [
        6062,
        6063
    ],
    "ngwe palaung": [
        6065,
        6066,
        6486
    ],
    "naijá": [
        6077
    ],
    "nigerian creole english": [
        6077
    ],
    "nigerian pidgin": [
        6077
    ],
    "nigerian pidgin english": [
        6077
    ],
    "northeastern pomo": [
        6093
    ],
    "northern pomo": [
        6097
    ],
    "ngng": [
        6121
    ],
    "névome": [
        6142
    ],
    "no’ok": [
        6142
    ],
    "norfolkese": [
        6149
    ],
    "norf’k": [
        6149
    ],
    "nana": [
        6150
    ],
    "nangaritjara": [
        6150
    ],
    "neo-solomonic": [
        6158
    ],
    "ngala pökot": [
        6174
    ],
    "ng’ala pokot": [
        6174
    ],
    "ng’ala": [
        6174
    ],
    "northern popoloca": [
        6197
    ],
    "northern pumi": [
        6209
    ],
    "northern pame": [
        6216
    ],
    "naga, poumai": [
        6221
    ],
    "nibon": [
        6227
    ],
    "nibong": [
        6227
    ],
    "nuntajɨyi": [
        6255
    ],
    "neshnabémwen": [
        6263
    ],
    "nishnabek": [
        6263
    ],
    "nawat": [
        6271
    ],
    "nicarao": [
        6271
    ],
    "northwestern pakhto": [
        6306
    ],
    "nation": [
        6310
    ],
    "naisl": [
        6310
    ],
    "north american indian sign language": [
        6310
    ],
    "nyanganyatjara": [
        6343
    ],
    "northern tehuelche": [
        6358
    ],
    "northeastern krumen": [
        6384
    ],
    "naga, jejara": [
        6392
    ],
    "north bolivian quechua": [
        6404
    ],
    "north la paz quechua": [
        6404
    ],
    "napo kichwa": [
        6412,
        6424
    ],
    "napo": [
        6424,
        6412,
        8898
    ],
    "north junín quechua": [
        6423
    ],
    "napo kichua": [
        6424
    ],
    "napo kichwa shimi": [
        6424
    ],
    "napo lowland quechua": [
        6424
    ],
    "napo lowland quichua": [
        6424
    ],
    "napo quichua": [
        6424
    ],
    "nunashimi": [
        6427
    ],
    "northern pastaza quichua": [
        6429
    ],
    "northern conchucos ancash quechua": [
        6440
    ],
    "northern conchucos quechua": [
        6440
    ],
    "nui": [
        6470
    ],
    "nung rawang": [
        6477,
        6478,
        6479,
        6480,
        6481,
        6482
    ],
    "noihe": [
        6485
    ],
    "northern bontoc": [
        6487
    ],
    "northern bontok": [
        6487
    ],
    "northern shilha": [
        6519,
        6520,
        6521,
        6522
    ],
    "n": [
        7884,
        6519,
        6520,
        6521,
        6522,
        6888,
        6906
    ],
    "net": [
        6523
    ],
    "nyaturu": [
        6524
    ],
    "nungu": [
        6525
    ],
    "naiang": [
        6538
    ],
    "njung": [
        6538
    ],
    "nyung": [
        6538
    ],
    "norwegian, traveller": [
        6546
    ],
    "norwegian traveller": [
        6546
    ],
    "nawar": [
        6560
    ],
    "nawari": [
        6560
    ],
    "near-eastern gypsy": [
        6560
    ],
    "near-eastern": [
        6560
    ],
    "northern lunda": [
        6568
    ],
    "nari nari": [
        6573
    ],
    "nari": [
        6573
    ],
    "nari-nari": [
        6573
    ],
    "narinari": [
        6573
    ],
    "narri-narri": [
        6573
    ],
    "nyalungwa": [
        6574
    ],
    "noang": [
        6586
    ],
    "northern roglai": [
        6586
    ],
    "niromblon": [
        6587
    ],
    "ndele": [
        6594
    ],
    "nale": [
        6595
    ],
    "ngardi": [
        6644
    ],
    "ngadi": [
        6644
    ],
    "nyardi": [
        6644
    ],
    "northern amami-oshima": [
        6646
    ],
    "northern amami-osima": [
        6646
    ],
    "nortenyo": [
        6659,
        7440
    ],
    "nkutuk": [
        6672
    ],
    "ngambay": [
        6691
    ],
    "ngambai": [
        6691
    ],
    "nsindak": [
        6714
    ],
    "nagpuri": [
        6726,
        6727
    ],
    "nagpuria": [
        6726,
        6727
    ],
    "north slavey": [
        6734,
        6735
    ],
    "northwestern sardinian": [
        6749
    ],
    "northeastern sardinian": [
        6758
    ],
    "ngnok": [
        6760
    ],
    "north sámi": [
        6770,
        6771
    ],
    "northern lapp": [
        6770,
        6771
    ],
    "northern saami": [
        6770,
        6771
    ],
    "northern sami": [
        6772,
        6773,
        6770,
        6771
    ],
    "norwegian saami": [
        6770,
        6771
    ],
    "northern selkups": [
        6786
    ],
    "nanerigé": [
        6787
    ],
    "naani": [
        6787
    ],
    "nandereke": [
        6787
    ],
    "nandergé": [
        6787
    ],
    "nanergué": [
        6787
    ],
    "nanergé": [
        6787
    ],
    "nanerige": [
        6787
    ],
    "nanerigé sénoufo": [
        6787
    ],
    "niangolo": [
        6790
    ],
    "nyarafolo": [
        6795
    ],
    "niafolo": [
        6795
    ],
    "niarafolo": [
        6795
    ],
    "nyarafolo senoufo": [
        6795
    ],
    "nyaʔafolido": [
        6795
    ],
    "natürliche gebärde": [
        6811
    ],
    "natürliche": [
        6811
    ],
    "nizaa": [
        6815
    ],
    "ninam": [
        6831
    ],
    "noogu": [
        6834
    ],
    "neme ta̲i̲kwappe": [
        6836
    ],
    "nyabungu": [
        6852
    ],
    "nte": [
        6859
    ],
    "nere": [
        6873
    ],
    "numbami": [
        6875
    ],
    "namrei": [
        6895
    ],
    "n’kep": [
        6933
    ],
    "nuõrttsääʹmǩiõll": [
        6980,
        6981
    ],
    "noon": [
        6994
    ],
    "non": [
        6994
    ],
    "none": [
        6994
    ],
    "nahavaq": [
        7010
    ],
    "nahapa": [
        7010
    ],
    "nsong": [
        7038
    ],
    "ntsuo": [
        7038
    ],
    "northeast luba": [
        7039
    ],
    "nenlhet": [
        7058
    ],
    "nafi": [
        7106
    ],
    "ngwane": [
        7127
    ],
    "northern sama": [
        7132,
        7133
    ],
    "northern sinama": [
        7132,
        7133
    ],
    "ninigo": [
        7135
    ],
    "northern subaanen": [
        7159
    ],
    "northern subanen": [
        7159
    ],
    "northern stieng": [
        7165
    ],
    "northwestern samo": [
        7167
    ],
    "northern straits salish": [
        7175
    ],
    "north mianmin": [
        7191
    ],
    "nausaku": [
        7192
    ],
    "na-našu": [
        7220
    ],
    "naš jezik": [
        7220
    ],
    "naš": [
        7220
    ],
    "northeastern samo": [
        7274
    ],
    "neo-chaldean": [
        7277
    ],
    "ngalum": [
        7283
    ],
    "nabesna": [
        7320
    ],
    "nee’aaneegn’": [
        7320
    ],
    "nyisunggu": [
        7332
    ],
    "north tairora": [
        7334
    ],
    "negro": [
        7342
    ],
    "nambei nyon": [
        7352
    ],
    "nambei": [
        7352
    ],
    "nyon": [
        7352
    ],
    "nee’anděg’": [
        7356
    ],
    "nüa": [
        7386,
        7387
    ],
    "nuea": [
        7386,
        7387
    ],
    "neua": [
        7386,
        7387
    ],
    "nue": [
        7386,
        7387
    ],
    "nü": [
        7386,
        7387
    ],
    "nö": [
        7386,
        7387
    ],
    "naas-dishili": [
        7396
    ],
    "nsur": [
        7396
    ],
    "northern sakai": [
        7409
    ],
    "nèhtuh temèèr": [
        7409
    ],
    "nèhtuh": [
        7409
    ],
    "nyang’ori": [
        7411
    ],
    "northern teke": [
        7415
    ],
    "naso": [
        7440
    ],
    "nagarege": [
        7453
    ],
    "nagarige": [
        7453
    ],
    "naghareghe": [
        7453
    ],
    "naturalis": [
        7455
    ],
    "nume": [
        7460
    ],
    "north-east gaua": [
        7460
    ],
    "north-east": [
        7460
    ],
    "northern tarahumara": [
        7473
    ],
    "nklapmx": [
        7479,
        7480
    ],
    "nle’kepmxcín": [
        7479,
        7480
    ],
    "ntlakapamux": [
        7479,
        7480
    ],
    "ntlakapmuk": [
        7479,
        7480
    ],
    "nahanni": [
        7484
    ],
    "northern tujia": [
        7522
    ],
    "naing": [
        7524
    ],
    "necaxa": [
        7551
    ],
    "northeast ambon": [
        7581
    ],
    "navava": [
        7588
    ],
    "northwestern tamang": [
        7599
    ],
    "niap": [
        7610
    ],
    "northern gabri": [
        7619
    ],
    "nɨfe": [
        7622
    ],
    "nafe": [
        7622
    ],
    "ncfe": [
        7622
    ],
    "neninafe": [
        7622
    ],
    "nxnincfe": [
        7622
    ],
    "nəfe": [
        7622
    ],
    "nɨninɨfe": [
        7622
    ],
    "nakaraan taha lenakel": [
        7623
    ],
    "nakaraan": [
        7623
    ],
    "nakharan taha lénakel": [
        7623
    ],
    "nakharan": [
        7623
    ],
    "netvaar": [
        7623
    ],
    "netwar": [
        7623
    ],
    "nɨtuar": [
        7623
    ],
    "nən-naka": [
        7625
    ],
    "north tanna": [
        7625
    ],
    "not tana": [
        7625
    ],
    "not": [
        7625,
        9180
    ],
    "napuanmen": [
        7627
    ],
    "namqom": [
        7639
    ],
    "northern totonac": [
        7649
    ],
    "neomelanesian": [
        7666
    ],
    "new guinea pidgin english": [
        7666
    ],
    "nesang": [
        7674
    ],
    "nyam-kad": [
        7674
    ],
    "nyam-kat": [
        7674
    ],
    "nyamkad": [
        7674
    ],
    "northern carolinian": [
        7678
    ],
    "nu̱ꞌ": [
        7702
    ],
    "nash": [
        7706
    ],
    "naga, tarao": [
        7713
    ],
    "nìꞌ": [
        7716
    ],
    "nì’": [
        7716
    ],
    "nánj nï’ïn": [
        7718
    ],
    "nánj": [
        7718
    ],
    "nï’ïn": [
        7718
    ],
    "northern toussian": [
        7742
    ],
    "namakaban": [
        7747
    ],
    "niitaka": [
        7747
    ],
    "northern tutchone": [
        7767
    ],
    "nyimatli": [
        7771
    ],
    "northeastern thai": [
        7772
    ],
    "ndoore": [
        7791
    ],
    "ndore": [
        7791
    ],
    "ng’aturkana": [
        7800
    ],
    "naga, tutsa": [
        7813
    ],
    "northern tiwa": [
        7823
    ],
    "northern monpa": [
        7828
    ],
    "nhai": [
        7870
    ],
    "novouygur": [
        7916,
        7917,
        7918
    ],
    "ndir": [
        7929
    ],
    "nano": [
        7957
    ],
    "njindingga": [
        7959,
        7960
    ],
    "naga, paungnyuan": [
        7963
    ],
    "ndaoe": [
        7967
    ],
    "north watut": [
        7968
    ],
    "ngarinyin": [
        7971
    ],
    "ngarinjin": [
        7971
    ],
    "northeast malakula": [
        7986
    ],
    "numic": [
        8023
    ],
    "nembao": [
        8025
    ],
    "narakureavar": [
        8045
    ],
    "narikkorava": [
        8045
    ],
    "narikoravar": [
        8045
    ],
    "northwestern !kung": [
        8052
    ],
    "northwestern !xun": [
        8052
    ],
    "northwestern ǃkung": [
        8052
    ],
    "nyali-tchabi": [
        8061
    ],
    "netherlands antilles creole english": [
        8081
    ],
    "nulu": [
        8095
    ],
    "northeastern jamiltepec mixtec": [
        8113
    ],
    "naxijen": [
        8117
    ],
    "noreste": [
        8117,
        8118,
        9134
    ],
    "nampula": [
        8123,
        8124
    ],
    "naxinanda": [
        8126
    ],
    "nguifi": [
        8126
    ],
    "naxinandana": [
        8127
    ],
    "nnandia": [
        8127
    ],
    "neve’ei": [
        8129
    ],
    "nabusian teget": [
        8129
    ],
    "nabusian": [
        8129
    ],
    "nefe’ei": [
        8129
    ],
    "neve'ei": [
        8129
    ],
    "nbule": [
        8145
    ],
    "nyindi vɨtèé": [
        8145
    ],
    "nyindi": [
        8145
    ],
    "northeast sahaptin": [
        8148
    ],
    "natick": [
        8160
    ],
    "nwa": [
        8161
    ],
    "nusari": [
        8176
    ],
    "nambuda": [
        8187
    ],
    "ngalia": [
        8187
    ],
    "ngaliya": [
        8187
    ],
    "ngallia": [
        8187
    ],
    "ngardilpa": [
        8187
    ],
    "njambalatji": [
        8187
    ],
    "nanidjara": [
        8191
    ],
    "nyaani": [
        8191
    ],
    "naljara": [
        8222
    ],
    "ngoleiadjara": [
        8222
    ],
    "nhawu": [
        8222
    ],
    "nonga": [
        8222
    ],
    "north wahgi": [
        8225
    ],
    "ngathan": [
        8232
    ],
    "nyan wiyau": [
        8244
    ],
    "nyan": [
        8244
    ],
    "ngomvya": [
        8246
    ],
    "ng’omvia": [
        8246
    ],
    "nukunukubara": [
        8252
    ],
    "namwaní": [
        8284,
        8285
    ],
    "ndzwani": [
        8292,
        8293
    ],
    "ndzwani comorian": [
        8292,
        8293
    ],
    "njuani": [
        8292,
        8293
    ],
    "northern wintun": [
        8300
    ],
    "ndjembe": [
        8316
    ],
    "nirmal": [
        8343,
        8344,
        8345,
        8346
    ],
    "ndú berthú": [
        8355
    ],
    "ndú": [
        8355
    ],
    "nganhcara": [
        8360
    ],
    "nantjara": [
        8360
    ],
    "ngandjara": [
        8360
    ],
    "ngantjeri": [
        8360
    ],
    "njinturawik-nganhcara": [
        8360
    ],
    "ngandehua": [
        8363
    ],
    "nyu": [
        8369,
        8370,
        8371
    ],
    "nghungar": [
        8381
    ],
    "noular": [
        8384
    ],
    "ngarukwillam": [
        8384
    ],
    "nadrogaa": [
        8387
    ],
    "nguro": [
        8417
    ],
    "ngulungbara": [
        8426
    ],
    "nkqeshe": [
        8452
    ],
    "ndu-faa-keelo": [
        8453
    ],
    "namuya": [
        8457
    ],
    "ngarangari": [
        8470
    ],
    "nagesia": [
        8487
    ],
    "nageswar": [
        8487
    ],
    "ngandowul": [
        8490
    ],
    "nago, northern": [
        8493
    ],
    "northern nago": [
        8493
    ],
    "nina": [
        8535
    ],
    "nahina": [
        8555
    ],
    "ngarigu": [
        8560
    ],
    "ngarago": [
        8560
    ],
    "ngarego": [
        8560
    ],
    "ngarico": [
        8560
    ],
    "ngarigo": [
        8560
    ],
    "ngarroogoo": [
        8560
    ],
    "ngarrugu": [
        8560
    ],
    "ngaryo": [
        8560
    ],
    "nguramal": [
        8560
    ],
    "ngoni": [
        8561,
        9172,
        9173,
        8566
    ],
    "ngoni (tanzania)": [
        8561
    ],
    "nganakarti": [
        8562
    ],
    "nanakari": [
        8562
    ],
    "nanakati": [
        8562
    ],
    "nhanhagardi": [
        8562
    ],
    "ngumbarl": [
        8563
    ],
    "ngombal": [
        8563
    ],
    "northern kankanay": [
        8564
    ],
    "ngoni (mozambique)": [
        8566
    ],
    "narragansett": [
        8569
    ],
    "nunukul": [
        8570,
        8676
    ],
    "ngundjan": [
        8570
    ],
    "noonuccal": [
        8570
    ],
    "noonukul": [
        8570
    ],
    "nukunul": [
        8570
    ],
    "nunagal": [
        8570
    ],
    "nunungal": [
        8570
    ],
    "nununkul": [
        8570
    ],
    "nyiyaparli": [
        8571
    ],
    "niabali": [
        8571
    ],
    "nijadali": [
        8571
    ],
    "njiabadi": [
        8571
    ],
    "njiabali": [
        8571
    ],
    "njijabadi": [
        8571
    ],
    "njijabali": [
        8571
    ],
    "njijapali": [
        8571
    ],
    "nyiyabali": [
        8571
    ],
    "nyiyapali": [
        8571
    ],
    "nyiypali": [
        8571
    ],
    "nebes": [
        8576
    ],
    "northeastern tasmanian": [
        8589
    ],
    "nuenonne": [
        8592
    ],
    "north midlands tasmanian": [
        8594
    ],
    "northern tasmanian": [
        8608
    ],
    "northwestern tasmanian": [
        8609
    ],
    "nararapi": [
        8631
    ],
    "northern oaxaca mixtec": [
        8646
    ],
    "nochistlán": [
        8648
    ],
    "northern tlaxiaco mixtec": [
        8656
    ],
    "nda’u": [
        8656
    ],
    "nanga man pagi": [
        8670,
        8671,
        8672
    ],
    "nudi": [
        8675
    ],
    "nayaka": [
        8675
    ],
    "naik kurumba": [
        8675
    ],
    "naik": [
        8675
    ],
    "naikan": [
        8675
    ],
    "nonstandard kannada": [
        8675
    ],
    "nayakan": [
        8675
    ],
    "ngunawal": [
        8676
    ],
    "ngoonawal": [
        8676
    ],
    "ngunnawal": [
        8676
    ],
    "ngunuwal": [
        8676
    ],
    "nungawal": [
        8676
    ],
    "napok": [
        8699
    ],
    "nobuk": [
        8699
    ],
    "nogukwabai": [
        8699
    ],
    "nopuk": [
        8699
    ],
    "nopukw": [
        8699
    ],
    "ngarrimouro": [
        8713
    ],
    "ngarrimowro": [
        8713,
        8960
    ],
    "nijya̱mi̱ niquejada": [
        8720
    ],
    "nijya̱mi̱": [
        8720
    ],
    "niquejada": [
        8720
    ],
    "nijyamii": [
        8720
    ],
    "nijyamïï nikyejaada": [
        8720
    ],
    "nijyamïï": [
        8720
    ],
    "nikyejaada": [
        8720
    ],
    "noki": [
        8736
    ],
    "nu gunu": [
        8738
    ],
    "nugunu (cameroon)": [
        8738
    ],
    "njambeta": [
        8739
    ],
    "nuasue": [
        8741
    ],
    "nukalonge": [
        8741
    ],
    "nyikobe": [
        8754
    ],
    "nyikuben": [
        8754
    ],
    "nyankpa": [
        8776
    ],
    "nyenkpa": [
        8776
    ],
    "nalyanapa": [
        8781
    ],
    "nasu": [
        8797,
        8953,
        8785,
        8949,
        8950
    ],
    "nasu, wusa": [
        8797
    ],
    "nesu": [
        8953,
        8797
    ],
    "naga, yimchungru": [
        8803
    ],
    "north awyu": [
        8807
    ],
    "nisu, northern": [
        8811
    ],
    "nasupho": [
        8811,
        8949,
        8950
    ],
    "northern nisu": [
        8811
    ],
    "northern yukaghir": [
        8816
    ],
    "northern yukagir": [
        8816
    ],
    "namupha": [
        8819
    ],
    "northern yali": [
        8831
    ],
    "naluo": [
        8835
    ],
    "naluo yi": [
        8835
    ],
    "naruo": [
        8835
    ],
    "nyelâyu": [
        8838
    ],
    "nielaiou": [
        8838
    ],
    "nielaiu": [
        8838
    ],
    "nyalayu": [
        8838
    ],
    "nyâlayu": [
        8838
    ],
    "northern muji": [
        8856
    ],
    "niluo": [
        8858
    ],
    "naukan": [
        8862
    ],
    "naukan siberian yupik": [
        8862
    ],
    "naukan yupik": [
        8862
    ],
    "naukanski": [
        8862
    ],
    "nevuqaq": [
        8862
    ],
    "nya korok": [
        8866
    ],
    "nya yendang": [
        8866
    ],
    "nyandang": [
        8866
    ],
    "nenets": [
        8895
    ],
    "nenec": [
        8895
    ],
    "nenetsy": [
        8895
    ],
    "nentse": [
        8895
    ],
    "nhengatu": [
        8896
    ],
    "nengatu": [
        8896
    ],
    "nheengatu": [
        8896
    ],
    "nheengatú": [
        8896
    ],
    "nyengato": [
        8896
    ],
    "nyengatú": [
        8896
    ],
    "napo buyang": [
        8898
    ],
    "nisi (china)": [
        8909
    ],
    "ngarrbal": [
        8920
    ],
    "ngarrubul": [
        8920
    ],
    "northern yukian": [
        8931
    ],
    "northern motilone": [
        8935
    ],
    "northern motilón": [
        8935
    ],
    "nalawonga": [
        8946
    ],
    "ngalawonga": [
        8946
    ],
    "ngalawongga": [
        8946
    ],
    "ngarla-warngga": [
        8946
    ],
    "ngaunmardi": [
        8946
    ],
    "ninanu": [
        8946
    ],
    "nasu, wumeng": [
        8953
    ],
    "neisu": [
        8953
    ],
    "nersu": [
        8953
    ],
    "ninghi": [
        8956
    ],
    "northern villa alta zapotec": [
        8986
    ],
    "ngazidja": [
        9005,
        9006
    ],
    "ngazidja comorian": [
        9005,
        9006
    ],
    "ngazija": [
        9005,
        9006
    ],
    "northern zhuang": [
        9016,
        9146,
        9147
    ],
    "northern chinese": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "ndrapa": [
        9043
    ],
    "ndae": [
        9044,
        9045
    ],
    "nanbu": [
        9044,
        9045,
        9047,
        9048,
        9181,
        9184,
        9188
    ],
    "noangx": [
        9047,
        9048
    ],
    "nong zhuang": [
        9047,
        9048
    ],
    "nong hua": [
        9047,
        9048
    ],
    "noangz": [
        9047,
        9048
    ],
    "nuangz": [
        9047,
        9048
    ],
    "nantuwara": [
        9071
    ],
    "nantuwaru": [
        9071
    ],
    "nganawara": [
        9071
    ],
    "nyangwe": [
        9082
    ],
    "negeri sembilan malay": [
        9089
    ],
    "negeri": [
        9089
    ],
    "ngarr": [
        9100
    ],
    "ngangikadre": [
        9100
    ],
    "nieng ó": [
        9110
    ],
    "nieng": [
        9110
    ],
    "naragani": [
        9111
    ],
    "north central zimatlan zapotec": [
        9116
    ],
    "numte oote": [
        9117
    ],
    "numte": [
        9117
    ],
    "northwestern tehuantepec zapotec": [
        9120
    ],
    "northwestern yautepec zapotec": [
        9121
    ],
    "northern isthmus zapotec": [
        9126
    ],
    "northeastern yautepec zapotec": [
        9129
    ],
    "northwestern pochutla zapotec": [
        9143
    ],
    "northern sapoteko": [
        9171
    ],
    "no linguistic content": [
        9180
    ],
    "not applicable": [
        9180
    ],
    "nung giang": [
        9181
    ],
    "nongz anx": [
        9184,
        9188
    ],
    "nongz": [
        9184,
        9188
    ],
    "nung an": [
        9184
    ],
    "nung chao": [
        9188
    ]
};
